// import { useState, useEffect } from 'react';
// import { Box, Paper, Typography, TextField, Button, IconButton, useMediaQuery, useTheme, Grid, Divider } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import DropdownProductCode from './DropdownProductCode';
// import DeleteIcon from '@mui/icons-material/Delete';
// import axios from 'axios';
// import { useAuth } from '../../../context/AuthContext';

// const ProductDetails = ({ initialData, onNext, clientData, connectionString }) => {
//     const { user, selectedCompany, loading } = useAuth();
//     const companyId = selectedCompany?.CompId || null;
//     const state = clientData?.details?.['State'] || '';
//     console.log(selectedCompany);
//     const compState = selectedCompany?.State || '';
//     console.log(compState, state);
//     const theme = useTheme();
//     const isSmall = useMediaQuery(theme.breakpoints.down('md'));

//     const [rows, setRows] = useState([]);
//     const [nextSrNo, setNextSrNo] = useState(1);
//     const [current, setCurrent] = useState({ Id: '', productCode: '', description: '', UnitId: '', unit: '', qty: 1, rate: 0, disc: 0, tax: 0, batchNo: '', expDate: '', serialNo: '', amount: '', taxAmount: '', remark: '', CGST: '0.00', SGST: '0.00', IGST: '0.00', UTGST: '0.00', GSTCess: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', TaxId: null });
//     const [totals, setTotals] = useState({ basic: 0, discount: 0, cgst: 0, sgst: 0, igst: 0, roundOff: 0, total: 0 });
//     const [errors, setErrors] = useState({});
//     const [editIndex, setEditIndex] = useState(null);
//     const [allProducts, setAllProducts] = useState([]);
//     const [unitOptions, setUnitOptions] = useState([]);
//     const [colorMap, setColorMap] = useState({});
//     const [sizeMap, setSizeMap] = useState({});
//     const [isInitialized, setIsInitialized] = useState(false); 
//     const API = connectionString;
//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const unitsRes = await axios.get(`${API}/api/unit/retrive`, { params: { companyId } });
//                 console.log(unitsRes.data);
//                 setUnitOptions(unitsRes.data); // Expecting [{ UnitId: 43, unit: "NOS" }, ...]
//                 const [cRes, sRes] = await Promise.all([
//                     axios.get(`${API}/api/colormaster`),
//                     axios.get(`${API}/api/sizemaster`)
//                 ]);
//                 const cm = {}, sm = {};
//                 cRes.data.forEach(c => (cm[c.colorId] = { name: c.itemColor, code: c.colorCode }));
//                 sRes.data.forEach(s => (sm[s.sizeId] = { name: s.itemSize, code: s.sizeCode }));
//                 setColorMap(cm);
//                 setSizeMap(sm);
//             } catch (error) {
//                 console.error('Error fetching product or unit data:', error);
//             }
//         };

//         fetchData();
//         loadAllProducts();
//     }, []);

//     const loadAllProducts = async () => {
//         try {
//             const res = await axios.get(`${API}/api/productdata/retrive`, { params: { companyId } });
//             setAllProducts(res.data || []);
//         } catch (e) {
//             console.error('Error fetching products:', e);
//         }
//     };

//     useEffect(() => {
//         if (isInitialized || !initialData?.tableData || !Array.isArray(initialData.tableData) || !unitOptions.length || !allProducts.length) {
//             return;
//         }

//         const initialRows = initialData.tableData.map((r, index) => {
//             const qty = Number(r.qty) || 0;
//             const rate = Number(r.rate) || 0;
//             const disc = Number(r.disc) || 0;
//             const taxableAmt = qty * rate * (1 - disc / 100);

//             const product = allProducts.find(p => p.Id === r.productId || p.itemCode === r.productCode);
//             let tax = Number(r.tax) || 0;
//             let taxAmount = taxableAmt * (tax / 100);
//             let cgst = '0.00', sgst = '0.00', igst = '0.00';
//             let cgstAmt = '0.00', sgstAmt = '0.00', igstAmt = '0.00';
//             let taxId = r.TaxId || null;

//             if (product) {
//                 tax = parseFloat(product.GST) || tax;
//                 taxId = product.TaxId || taxId;
//                 taxAmount = taxableAmt * (tax / 100);
//                 cgst = state === compState ? (tax / 2).toFixed(2) : '0.00';
//                 sgst = state === compState ? (tax / 2).toFixed(2) : '0.00';
//                 igst = state !== compState ? tax.toFixed(2) : '0.00';
//                 cgstAmt = state === compState ? (taxAmount / 2).toFixed(2) : '0.00';
//                 sgstAmt = state === compState ? (taxAmount / 2).toFixed(2) : '0.00';
//                 igstAmt = state !== compState ? taxAmount.toFixed(2) : '0.00';
//             } else {
//                 taxAmount = taxableAmt * (tax / 100);
//                 cgst = String(r.CGST || (state === compState ? (tax / 2) : 0)).toFixed(2);
//                 sgst = String(r.SGST || (state === compState ? (tax / 2) : 0)).toFixed(2);
//                 igst = String(r.IGST || (state !== compState ? tax : 0)).toFixed(2);
//                 cgstAmt = Number(r.CGSTAmt || (state === compState ? (taxAmount / 2) : 0)).toFixed(2);
//                 sgstAmt = Number(r.SGSTAmt || (state === compState ? (taxAmount / 2) : 0)).toFixed(2);
//                 igstAmt = Number(r.IGSTAmt || (state !== compState ? taxAmount : 0)).toFixed(2);
//             }

//             const matchedUnit = unitOptions.find(u => String(u.UnitId) === String(r.UnitId)) || unitOptions.find(u => String(u.UnitId) === String(r.unit)) || unitOptions.find(u => u.unit?.toLowerCase() === String(r.unit).toLowerCase());

//             return { ...r, remark: typeof r.remark === "string" && r.remark.trim() !== r.description?.trim() ? r.remark : "", productId: r.productId || r.Id || r.id || '', UnitId: matchedUnit ? String(matchedUnit.UnitId) : r.UnitId || '', unit: matchedUnit ? matchedUnit.unit : r.unit || '', qty, rate, disc, tax, TaxableAmt: Number(r.TaxableAmt) || taxableAmt.toFixed(2), taxAmount: Number(r.taxAmount) || taxAmount.toFixed(2), amount: Number(r.TaxableAmt) || taxableAmt.toFixed(2), CGST: cgst, SGST: sgst, IGST: igst, CGSTAmt: cgstAmt, SGSTAmt: sgstAmt, IGSTAmt: igstAmt, UTGST: String(r.UTGST || '0.00'), GSTCess: String(r.GSTCess || '0.00'), TaxId: taxId, srNo: initialData.tableData.length - index };
//         });

//         setRows(initialRows);
//         setNextSrNo(initialRows.length + 1);
//         setIsInitialized(true);
//     }, [initialData?.tableData, unitOptions, allProducts, state, compState, isInitialized]);

//     useEffect(() => {
//         const qty = Number(current.qty) || 0;
//         const rate = Number(current.rate) || 0;
//         const disc = Number(current.disc) || 0;
//         const tax = Number(current.tax) || 0;
//         const taxableAmt = qty * rate * (1 - disc / 100);
//         const taxAmount = taxableAmt * (tax / 100);
//         setCurrent(prev => ({
//             ...prev,
//             TaxableAmt: taxableAmt.toFixed(2),
//             amount: taxableAmt.toFixed(2),
//             taxAmount: taxAmount.toFixed(2),
//             CGST: state === compState ? (tax / 2).toFixed(2) : '0.00',
//             SGST: state === compState ? (tax / 2).toFixed(2) : '0.00',
//             IGST: state !== compState ? tax.toFixed(2) : '0.00',
//             CGSTAmt: state === compState ? (taxAmount / 2).toFixed(2) : '0.00',
//             SGSTAmt: state === compState ? (taxAmount / 2).toFixed(2) : '0.00',
//             IGSTAmt: state !== compState ? taxAmount.toFixed(2) : '0.00'
//         }));
//     }, [current.qty, current.rate, current.disc, current.tax, state, compState]);

//     // Inside useEffect for totals calculation
//     // REPLACE your existing totals useEffect with this
//     useEffect(() => {
//         const n = v => Number(v || 0);
//         const isSameState = state === compState;

//         let basicAmountSum = 0;    // sum of per-row amount (post-discount taxable)
//         let discountTotal = 0;
//         let cgstTotal = 0;
//         let sgstTotal = 0;
//         let igstTotal = 0;

//         rows.forEach(r => {
//             const qty = n(r.qty);
//             const rate = n(r.rate);
//             const gross = qty * rate;                        // before discount (for fallback)
//             const taxable = n(r.amount || r.TaxableAmt);    // use row.amount (post-discount) as requested
//             const discAmtRow = n(r.DiscAmt) || Math.max(0, gross - taxable); // prefer DiscAmt, else gross - taxable
//             const taxPct = n(r.tax);

//             // prefer given tax amounts if present (safer), else compute from taxable & taxPct
//             const cgstAmtRow = (r.CGSTAmt != null && r.CGSTAmt !== '') ? n(r.CGSTAmt) : (isSameState ? (taxable * (taxPct / 100) / 2) : 0);
//             const sgstAmtRow = (r.SGSTAmt != null && r.SGSTAmt !== '') ? n(r.SGSTAmt) : (isSameState ? (taxable * (taxPct / 100) / 2) : 0);
//             const igstAmtRow = (r.IGSTAmt != null && r.IGSTAmt !== '') ? n(r.IGSTAmt) : (isSameState ? 0 : (taxable * (taxPct / 100)));

//             basicAmountSum += taxable;
//             discountTotal += discAmtRow;
//             cgstTotal += cgstAmtRow;
//             sgstTotal += sgstAmtRow;
//             igstTotal += igstAmtRow;
//         });

//         const totalTax = cgstTotal + sgstTotal + igstTotal;
//         // final based on required behaviour: basic (post-discount) + tax
//         const finalAmount = basicAmountSum + totalTax;

//         // round up to next rupee (preserve existing behaviour)
//         const roundedFinal = Math.ceil(finalAmount);
//         const roundOff = Number((roundedFinal - finalAmount).toFixed(2));

//         setTotals({
//             basic: basicAmountSum.toFixed(2),
//             discount: discountTotal.toFixed(2),
//             cgst: cgstTotal.toFixed(2),
//             sgst: sgstTotal.toFixed(2),
//             igst: igstTotal.toFixed(2),
//             roundOff: roundOff.toFixed(2),
//             total: roundedFinal.toFixed(2)
//         });
//     }, [rows, state, compState]);

//     const handleChange = field => e => {
//         if (field === 'UnitId') {
//             const selectedUnit = unitOptions.find(u => u.UnitId === Number(e.target.value));
//             setCurrent(prev => ({
//                 ...prev,
//                 UnitId: e.target.value,
//                 unit: selectedUnit ? selectedUnit.unit : ''
//             }));
//         } else {
//             setCurrent(prev => ({ ...prev, [field]: e.target.value }));
//         }
//     };

//     const handleSelect = product => {
//         const matchedUnit = unitOptions.find(opt => {
//             if (product.UnitId && opt.UnitId === product.UnitId) return true;
//             if (product.Unit && opt.unit?.toLowerCase() === product.Unit.toLowerCase()) return true;
//             if (product.unit && opt.unit?.toLowerCase() === product.unit.toLowerCase()) return true;
//             return false;
//         });
//         const qty = 1;
//         const rate = Number(product.saleRate) || 0;
//         const disc = Number(product.saleDiscount) || 0;
//         const tax = parseFloat(product.GST) || 0;
//         const taxId = product.TaxId || null;
//         const taxableAmt = qty * rate * (1 - disc / 100);
//         const taxAmount = taxableAmt * (tax / 100);
//         setCurrent({
//             Id: product.Id?.toString() || '',
//             productCode: product.itemCode || '',
//             description: product.description || '',
//             UnitId: matchedUnit ? String(matchedUnit.UnitId) : '',
//             unit: matchedUnit ? matchedUnit.unit : '',
//             qty,
//             rate,
//             disc,
//             tax,
//             batchNo: '',
//             expDate: '',
//             serialNo: '',
//             amount: taxableAmt.toFixed(2),
//             taxAmount: taxAmount.toFixed(2),
//             remark: '',
//             TaxId: taxId,
//             CGST: state === compState ? (tax / 2).toFixed(2) : '0.00',
//             SGST: state === compState ? (tax / 2).toFixed(2) : '0.00',
//             IGST: state !== compState ? tax.toFixed(2) : '0.00',
//             UTGST: '0.00',
//             GSTCess: '0.00',
//             CGSTAmt: state === compState ? (taxAmount / 2).toFixed(2) : '0.00',
//             SGSTAmt: state === compState ? (taxAmount / 2).toFixed(2) : '0.00',
//             IGSTAmt: state !== compState ? taxAmount.toFixed(2) : '0.00',
//             TaxableAmt: taxableAmt.toFixed(2)
//         });
//         setEditIndex(null);
//         setErrors({});
//     };

//     const addProduct = () => {
//         const errs = {};
//         const messages = new Set();
//         const requiredFields = ['productCode', 'description', 'UnitId', 'qty', 'rate', 'disc', 'tax'];

//         requiredFields.forEach(field => {
//             if (!current[field] && current[field] !== 0) {
//                 errs[field] = 'Required';
//                 messages.add('All fields are required.');
//             }
//         });

//         if (!current.qty || Number(current.qty) <= 0) {
//             errs.qty = 'Must be > 0';
//             messages.add('Qty must be greater than 0');
//         }

//         if (current.rate < 0) {
//             errs.rate = 'Cannot be negative';
//             messages.add('Rate cannot be negative');
//         }

//         if (current.disc < 0) {
//             errs.disc = 'Cannot be negative';
//             messages.add('Discount cannot be negative');
//         }

//         if (current.disc > 100) {
//             errs.disc = 'Cannot be more than 100';
//             messages.add('Discount cannot be more than 100');
//         }

//         if (messages.size > 0) {
//             errs.global = Array.from(messages);
//             setErrors(errs);
//             return;
//         }

//         const qty = Number(current.qty) || 0;
//         const rate = Number(current.rate) || 0;
//         const disc = Number(current.disc) || 0;
//         const tax = Number(current.tax) || 0;
//         const taxableAmt = qty * rate * (1 - disc / 100);
//         const taxAmount = taxableAmt * (tax / 100);

//         const row = {
//             ...current,
//             productId: current.Id,
//             qty,
//             rate,
//             disc,
//             tax,
//             remark: current.remark?.trim() !== '' ? current.remark : '',
//             TaxableAmt: taxableAmt.toFixed(2),
//             taxAmount: taxAmount.toFixed(2),
//             amount: taxableAmt.toFixed(2),
//             CGST: state === compState ? (tax / 2).toFixed(2) : '0.00',
//             SGST: state === compState ? (tax / 2).toFixed(2) : '0.00',
//             IGST: state !== compState ? tax.toFixed(2) : '0.00',
//             CGSTAmt: state === compState ? (taxAmount / 2).toFixed(2) : '0.00',
//             SGSTAmt: state === compState ? (taxAmount / 2).toFixed(2) : '0.00',
//             IGSTAmt: state !== compState ? taxAmount.toFixed(2) : '0.00',
//             UTGST: current.UTGST,
//             GSTCess: current.GSTCess,
//             TaxId: current.TaxId,
//             srNo: editIndex != null ? rows[editIndex].srNo : nextSrNo
//         };

//         const existingRowIndex = rows.findIndex(
//             (r, i) => r.productCode === current.productCode && i !== editIndex
//         );

//         if (existingRowIndex !== -1 && editIndex == null) {
//             setRows(prev =>
//                 prev.map((r, i) => {
//                     if (i === existingRowIndex) {
//                         const newQty = Number(r.qty) + qty;
//                         const newTaxableAmt = newQty * rate * (1 - disc / 100);
//                         const newTaxAmount = newTaxableAmt * (tax / 100);
//                         return {
//                             ...r,
//                             qty: newQty,
//                             rate,
//                             disc,
//                             tax,
//                             remark: current.remark?.trim() !== '' ? current.remark : '',
//                             TaxableAmt: newTaxableAmt.toFixed(2),
//                             taxAmount: newTaxAmount.toFixed(2),
//                             amount: newTaxableAmt.toFixed(2),
//                             CGST: state === compState ? (tax / 2).toFixed(2) : '0.00',
//                             SGST: state === compState ? (tax / 2).toFixed(2) : '0.00',
//                             IGST: state !== compState ? tax.toFixed(2) : '0.00',
//                             CGSTAmt: state === compState ? (newTaxAmount / 2).toFixed(2) : '0.00',
//                             SGSTAmt: state === compState ? (newTaxAmount / 2).toFixed(2) : '0.00',
//                             IGSTAmt: state !== compState ? newTaxAmount.toFixed(2) : '0.00',
//                             UTGST: current.UTGST,
//                             GSTCess: current.GSTCess,
//                             TaxId: current.TaxId
//                         };
//                     }
//                     return r;
//                 })
//             );
//         } else {
//             if (editIndex != null) {
//                 setRows(prev => prev.map((r, i) => (i === editIndex ? row : r)));
//             } else {
//                 setRows(prev => [row, ...prev]);
//                 setNextSrNo(prev => prev + 1);
//             }
//         }

//         setCurrent({ Id: '', productCode: '', description: '', UnitId: '', unit: '', qty: 1, rate: 0, disc: 0, tax: 0, remark: '', CGST: '0.00', SGST: '0.00', IGST: '0.00', UTGST: '0.00', GSTCess: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', taxAmount: '', amount: '', TaxId: null });
//         setErrors({});
//         setEditIndex(null);
//     };

//     const editRow = idx => {
//         const row = rows[idx];
//         const matchedUnit = unitOptions.find(u => String(u.UnitId) === String(row.UnitId)) || unitOptions.find(u => String(u.UnitId) === String(row.unit)) || unitOptions.find(u => u.unit?.toLowerCase() === String(row.unit).toLowerCase());

//         setCurrent({
//             ...row,
//             Id: row.productId,
//             UnitId: matchedUnit ? String(matchedUnit.UnitId) : row.UnitId || '',
//             unit: matchedUnit ? matchedUnit.unit : row.unit || '',
//             CGST: String(row.CGST || '0.00'),
//             SGST: String(row.SGST || '0.00'),
//             IGST: String(row.IGST || '0.00'),
//             CGSTAmt: String(row.CGSTAmt || '0.00'),
//             SGSTAmt: String(row.SGSTAmt || '0.00'),
//             IGSTAmt: String(row.IGSTAmt || '0.00'),
//             UTGST: String(row.UTGST || '0.00'),
//             GSTCess: String(row.GSTCess || '0.00'),
//             TaxableAmt: String(row.TaxableAmt || '0.00'),
//             taxAmount: String(row.taxAmount || '0.00'),
//             amount: String(row.amount || '0.00'),
//             TaxId: row.TaxId || null
//         });
//         setEditIndex(idx);
//     };

//     const deleteRow = idx => {
//         setRows(prev => prev.filter((_, i) => i !== idx));

//         // ALWAYS reset edit state when any row is deleted
//         // This prevents stale state issues completely
//         setCurrent({
//             Id: '',
//             productCode: '',
//             description: '',
//             UnitId: '',
//             unit: '',
//             qty: 1,
//             rate: 0,
//             disc: 0,
//             tax: 0,
//             remark: '',
//             CGST: '0.00',
//             SGST: '0.00',
//             IGST: '0.00',
//             UTGST: '0.00',
//             GSTCess: '0.00',
//             CGSTAmt: '0.00',
//             SGSTAmt: '0.00',
//             IGSTAmt: '0.00',
//             TaxableAmt: '0.00',
//             taxAmount: '',
//             amount: '',
//             TaxId: null
//         });
//         setEditIndex(null);
//         setErrors({});
//     };

//     // Inside handleNext function
//     // REPLACE your old handleNext with this
//     const handleNext = () => {
//         if (rows.length === 0) {
//             setErrors({ global: 'Add at least one product' });
//             return;
//         }

//         const isSameState = state === compState;

//         const payloadRows = rows.map(r => {
//             const qty = Number(r.qty) || 0;
//             const rate = Number(r.rate) || 0;
//             const gross = qty * rate;
//             const taxable = Number(r.amount || r.TaxableAmt) || 0; // per requirement: amount is post-discount
//             const discAmt = Number(r.DiscAmt) || Math.max(0, gross - taxable);
//             const taxPct = Number(r.tax) || 0;
//             const taxAmt = Number(r.taxAmount) || (taxable * (taxPct / 100));

//             // prefer explicit per-row tax splits if available, else split deterministically
//             const cgstAmt = (r.CGSTAmt != null && r.CGSTAmt !== '') ? Number(r.CGSTAmt) : (isSameState ? taxAmt / 2 : 0);
//             const sgstAmt = (r.SGSTAmt != null && r.SGSTAmt !== '') ? Number(r.SGSTAmt) : (isSameState ? taxAmt / 2 : 0);
//             const igstAmt = (r.IGSTAmt != null && r.IGSTAmt !== '') ? Number(r.IGSTAmt) : (isSameState ? 0 : taxAmt);

//             return {
//                 productId: r.productId,
//                 productCode: r.productCode,
//                 description: r.description,
//                 unit: r.unit,
//                 UnitId: Number(r.UnitId) || null,
//                 qty,
//                 rate,
//                 disc: Number(r.disc) || 0,
//                 tax: taxPct,
//                 batchNo: r.batchNo || '',
//                 expDate: r.expDate || null,
//                 serialNo: r.serialNo || '',
//                 remark: r.remark?.trim() !== '' ? r.remark : '',
//                 gross: Number(gross.toFixed(2)),               // optional: pre-discount for backend if useful
//                 amount: Number(taxable.toFixed(2)),            // post-discount taxable (basic)
//                 DiscAmt: Number(discAmt.toFixed(2)),
//                 taxAmount: Number(taxAmt.toFixed(2)),
//                 srNo: r.srNo,
//                 TaxId: r.TaxId || null,
//                 CGST: isSameState ? Number((taxPct / 2).toFixed(2)) : 0,
//                 SGST: isSameState ? Number((taxPct / 2).toFixed(2)) : 0,
//                 IGST: isSameState ? 0 : Number(taxPct.toFixed(2)),
//                 CGSTAmt: Number(cgstAmt.toFixed(2)),
//                 SGSTAmt: Number(sgstAmt.toFixed(2)),
//                 IGSTAmt: Number(igstAmt.toFixed(2)),
//                 UTGST: r.UTGST || '0.00',
//                 GSTCess: r.GSTCess || '0.00'
//             };
//         });

//         // Summary computed from payloadRows, using amount as basic (post-discount)
//         const totalBasic = payloadRows.reduce((sum, r) => sum + (Number(r.amount) || 0), 0);
//         const discountAmt = payloadRows.reduce((sum, r) => sum + (Number(r.DiscAmt) || 0), 0);
//         const cgst = payloadRows.reduce((sum, r) => sum + (Number(r.CGSTAmt) || 0), 0);
//         const sgst = payloadRows.reduce((sum, r) => sum + (Number(r.SGSTAmt) || 0), 0);
//         const igst = payloadRows.reduce((sum, r) => sum + (Number(r.IGSTAmt) || 0), 0);

//         const totalTax = cgst + sgst + igst;
//         const finalAmount = totalBasic + totalTax;

//         const roundedFinal = Math.ceil(finalAmount);
//         const roundOff = Number((roundedFinal - finalAmount).toFixed(2));

//         const payload = {
//             tableData: payloadRows,
//             summary: {
//                 basic: Number(totalBasic.toFixed(2)),   // sum of post-discount amounts (per your requirement)
//                 discount: Number(discountAmt.toFixed(2)),
//                 cgst: Number(cgst.toFixed(2)),
//                 sgst: Number(sgst.toFixed(2)),
//                 igst: Number(igst.toFixed(2)),
//                 roundOff: Number(roundOff.toFixed(2)),
//                 total: Number(roundedFinal.toFixed(2))
//             }
//         };

//         onNext(payload);
//     };

//     const formatINR = val => {
//         const num = Number(val) || 0;
//         return num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//     };

//     const columns = [
//         { field: 'srNo', headerName: '#', width: 40, align: 'center', headerAlign: 'center' },
//         {
//             field: 'product', headerName: 'Product', flex: 1, sortable: false, filterable: false,
//             renderCell: params => {
//                 const { productCode, description, unit, tax, batchNo, expDate, serialNo, remark, CGSTAmt, SGSTAmt, IGSTAmt } = params.row;
//                 console.log(params.row);
//                 const isSameState = state === compState;
//                 return (
//                     <Box sx={{ py: 0.5, display: 'flex', flexDirection: 'column' }}>
//                         <Box>
//                             <Typography variant="body2" fontWeight="bold" component="div" sx={{ cursor: 'pointer', color: '#1877F2', textDecoration: 'underline', fontSize: '0.85rem' }}
//                                 onClick={e => {
//                                     e.stopPropagation();
//                                     editRow(params.row.index);
//                                 }}
//                             >
//                                 {productCode}
//                             </Typography>
//                             <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.85rem' }}>
//                                 {description}
//                             </Typography>
//                         </Box>
//                         <Typography variant="caption" display="block">
//                             Unit: {unit || 'N/A'} | GST: {tax}%
//                         </Typography>
//                         <Typography variant="caption" display="block" color="text.secondary">
//                             {isSameState ? `SGST: ₹${formatINR(SGSTAmt)} + CGST: ₹${formatINR(CGSTAmt)}` : `IGST: ₹${formatINR(IGSTAmt)}`}
//                         </Typography>
//                         {(batchNo || expDate || serialNo) && (
//                             <Typography variant="caption" display="block">
//                                 {batchNo && `Batch: ${batchNo}`}
//                                 {expDate && ` | Exp: ${expDate}`}
//                             </Typography>
//                         )}
//                         {remark && (
//                             <Typography variant="caption" display="block" color="text.secondary">
//                                 Remark: {remark}
//                             </Typography>
//                         )}
//                     </Box>
//                 );
//             }
//         },
//         { field: 'qty', headerName: 'Qty', width: 50, align: 'center', headerAlign: 'center' },
//         { field: 'rate', headerName: 'Rate', width: 100, align: 'right', headerAlign: 'center', renderCell: params => `₹${formatINR(params.row.rate)}` },
//         { field: 'disc', headerName: 'Disc (%)', width: 50, align: 'center', headerAlign: 'center' },
//         { field: 'amount', headerName: 'Amount ₹', width: 100, align: 'right', headerAlign: 'right', renderCell: params => `₹${formatINR(Number(params.row.TaxableAmt || 0))}` },
//         {
//             width: 30, sortable: false, filterable: false, align: 'center', headerAlign: 'center',
//             renderCell: params => (
//                 <IconButton size="small" onClick={() => deleteRow(params.row.index)} color="error">
//                     <DeleteIcon fontSize="small" />
//                 </IconButton>
//             )
//         }
//     ];

//     return (
//         <Paper sx={{ p: isSmall ? 1 : 1, overflowX: 'hidden' }}>
//             <Box display="flex" flexDirection={isSmall ? 'column' : 'row'} gap={2} sx={{ width: '100%', boxSizing: 'border-box', flexWrap: isSmall ? 'wrap' : 'nowrap', overflow: 'hidden' }} >
//                 <Box display="flex" flexDirection="column" gap={2} sx={{ width: '100%', maxWidth: isSmall ? '100%' : 420, boxSizing: 'border-box', p: 2, borderRight: isSmall ? 'none' : '1px solid #e0e0e0' }} >
//                     <Box>
//                         <DropdownProductCode id="productCode" options={allProducts} value={current.productCode} onSelect={handleSelect} onNewProductAdded={loadAllProducts} connectionString={connectionString} />
//                         {!!errors.productCode && (
//                             <Typography color="error" variant="caption">
//                                 {errors.productCode}
//                             </Typography>
//                         )}
//                     </Box>
//                     <TextField label="Description" fullWidth multiline minRows={1} size="small" placeholder="Enter product description" value={current.description} onChange={handleChange('description')} sx={{ '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 40 }, '& .MuiOutlinedInput-inputMultiline': { padding: '8px 12px', minHeight: '80px' } }} />
//                     <Box display="flex" flexDirection="row" gap={1.5}>
//                         <TextField label="Unit" select fullWidth size='small' value={String(current.UnitId)} onChange={handleChange('UnitId')} SelectProps={{ native: true }} sx={{ '& .MuiOutlinedInput-root': { height: 40, alignItems: 'center' } }} >
//                             <option value=""></option>
//                             {unitOptions.map(u => (
//                                 <option key={u.UnitId} value={u.UnitId}>
//                                     {u.unit}
//                                 </option>
//                             ))}
//                         </TextField>
//                         <TextField label="Tax(%)" fullWidth type="number" disabled value={current.tax} onChange={handleChange('tax')} sx={{ '& .MuiOutlinedInput-root': { height: 40, alignItems: 'center' } }} />
//                     </Box>
//                     <Box display="flex" flexDirection="row" gap={1.5}>
//                         <TextField label="Qty" fullWidth type="number" inputProps={{ min: 0, step: 'any' }} value={current.qty} onChange={handleChange('qty')} error={!!errors.qty} helperText={errors.qty} sx={{ '& .MuiOutlinedInput-root': { height: 40, alignItems: 'center' } }} />
//                         <TextField label="Rate" fullWidth type="number" inputProps={{ min: 0 }} value={current.rate} onChange={handleChange('rate')} sx={{ '& .MuiOutlinedInput-root': { height: 40, alignItems: 'center' } }} />
//                         <TextField label="Disc%" fullWidth type="number" inputProps={{ min: 0, max: 100 }} value={current.disc} onChange={handleChange('disc')} sx={{ '& .MuiOutlinedInput-root': { height: 40, alignItems: 'center' } }} />
//                     </Box>
//                     <TextField label="Amount" fullWidth disabled type="number" size="small" value={current.amount} sx={{ '& .MuiOutlinedInput-root': { height: 40, alignItems: 'center' } }} />
//                     <Box>
//                         <TextField label="Remark" fullWidth multiline minRows={1} maxRows={3} size="small" value={current.remark || ''} onChange={handleChange('remark')} sx={{ '& .MuiOutlinedInput-root': { height: 40, resize: 'vertical', overflow: 'hidden' } }} />
//                     </Box>
//                     <Box display="flex" justifyContent="center">
//                         <Button variant="outlined" onClick={addProduct} sx={{ minWidth: 180 }}>
//                             {editIndex != null ? 'Update Product' : 'Add Product'}
//                         </Button>
//                     </Box>
//                 </Box>
//                 <Box sx={{ width: isSmall ? '100%' : 670, maxWidth: '100%', p: isSmall ? 0 : 0, pl: 2, marginTop: isSmall ? 2 : -4, flexShrink: 0 }}>
//                     <DataGrid

//                         rows={rows.map((r, i) => ({ ...r, id: i + 1, index: i }))}
//                         columns={columns}
//                         getRowHeight={() => 'auto'}
//                         autoHeight
//                         disableRowSelectionOnClick
//                         hideFooter
//                         sx={{
//                             mt: 5,
//                             border: '1px solid #cbd5e1',
//                             borderRadius: 1,
//                             '& .MuiDataGrid-columnHeaders': { minHeight: 55, maxHeight: 55 },
//                             '& .MuiDataGrid-columnHeader': { backgroundColor: '#f0f0f0', paddingTop: '4px', paddingBottom: '4px', height: 42, lineHeight: '1.2rem', fontSize: '13px' },
//                             '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#edf2feff' },
//                             '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#ffffff' }
//                         }}
//                     />
//                     <Box mt={3}>
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                             <Typography>Basic Amount</Typography>
//                             <Typography>₹{formatINR(totals.basic)}</Typography>
//                         </Grid>
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                             <Typography>Discounted Amount</Typography>
//                             <Typography>₹{formatINR(totals.discount)}</Typography>
//                         </Grid>
//                         {state === compState ? (
//                             <>
//                                 <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                                     <Typography>CGST</Typography>
//                                     <Typography>₹{formatINR(totals.cgst)}</Typography>
//                                 </Grid>
//                                 <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                                     <Typography>SGST</Typography>
//                                     <Typography>₹{formatINR(totals.sgst)}</Typography>
//                                 </Grid>
//                             </>
//                         ) : (
//                             totals.igst > 0 && (
//                                 <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                                     <Typography>IGST</Typography>
//                                     <Typography>₹{formatINR(totals.igst)}</Typography>
//                                 </Grid>
//                             )
//                         )}
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                             <Typography>Round Off (+)</Typography>
//                             <Typography>₹{formatINR(totals.roundOff)}</Typography>
//                         </Grid>
//                         <Divider sx={{ my: 1 }} />
//                         <Grid container justifyContent="space-between" alignItems="center">
//                             <Typography fontWeight={600}>Total Amount</Typography>
//                             <Typography fontWeight={600}>₹{formatINR(totals.total)}</Typography>
//                         </Grid>
//                     </Box>
//                 </Box>
//             </Box>
//             {!!errors.global && (
//                 <Typography color="error" sx={{ mt: 2 }}>
//                     {errors.global}
//                 </Typography>
//             )}
//             <Box mt={3} display="flex" justifyContent="flex-end">
//                 <Button variant="contained" onClick={handleNext} disabled={editIndex !== null}>
//                     Next
//                 </Button>
//             </Box>
//         </Paper>
//     );
// };

// export default ProductDetails;

import { useState, useEffect, useRef, useMemo } from 'react';
import { Box, Paper, Typography, TextField, Button, IconButton, useMediaQuery, useTheme, Grid, Divider, Snackbar, Alert, Dialog, DialogTitle, DialogContent, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DataGrid } from '@mui/x-data-grid';
import DropdownProductCode from './DropdownProductCode';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import { useAuth } from '../../../context/AuthContext';
import EditIcon from '@mui/icons-material/Edit';
import Dropdown from '../../../components/Dropdown';
import { useVisibleColumns } from '../../../hooks/useVisibleColumns';
import { useUserDefine } from '../../../context/UserDefineContext';
import { COL, DEFAULT_LABELS } from '../../../constants/columnConstants';
import { useStockValidation } from '../../../hooks/useStockValidation';

/**
 * Normalizes state names for consistent comparison
 * Handles: mixed case, leading/trailing spaces, multiple spaces
 */
const normalizeState = (state) => {
    return (state || '')
        .trim()                    // Remove leading/trailing spaces
        .replace(/\s+/g, ' ')      // Replace multiple spaces with single space
        .toUpperCase();            // Convert to uppercase
};

/**
 * Compares two states safely
 */
const areSameState = (state1, state2) => {
    return normalizeState(state1) === normalizeState(state2);
};

// "Apply in Amt = Pkg*Qty*Rate?" — when this configure is enabled, a Pkg field
// containing anything that isn't a clean number (letters/special characters) must
// make the Pkg*Qty*Rate calculation come out as 0, instead of calculateAmount()'s
// own internal `Number(pkg) || 1` silently promoting invalid input back to 1.
// Blank/null/undefined Pkg is untouched — it still defaults to 1 (existing
// behavior for a fresh row before the user has typed a Pkg value).
const isGarbagePkg = (rawPkg) =>
    rawPkg !== '' && rawPkg !== null && rawPkg !== undefined && Number.isNaN(Number(rawPkg));

const getAmountCalcSafe = (qty, rate, rawPkg, disc, isApplyPkgInAmtEnabled, calculateAmount) => {
    if (isApplyPkgInAmtEnabled && isGarbagePkg(rawPkg)) {
        return { gross: 0, taxable: 0 };
    }
    return calculateAmount(qty, rate, rawPkg, disc);
};

const ProductDetails = ({ initialData, onNext, clientData, connectionString, isLocked, onRowsChange }) => {
    const { user, selectedCompany, loading } = useAuth();
    const { isColVisible, getColLabel } = useVisibleColumns('QUOT');
    const { getSelectedCharges, getChargeItemId, userDefineData } = useUserDefine();
    const { isLastSaleRateEnabled, getLastSaleRate, isApplyPkgInAmtEnabled, calculateAmount, isApplyMRPInSaleEnabled, calculateSaleRateFromMRP } = useStockValidation(connectionString, selectedCompany?.CompId);
    // getSelectedCharges() returns a brand-new array on every call (Array.filter),
    // even when userDefineData hasn't changed — used as a useEffect dependency
    // further down, an unstable reference there re-fires those effects (and their
    // setState calls) on every render, causing an infinite render loop. Memoize
    // on userDefineData (the actual stable source data) so the array reference
    // only changes when the underlying charges data actually changes.
    const additionalCharges = useMemo(() => getSelectedCharges(), [userDefineData]);
    const [chargesDialogOpen, setChargesDialogOpen] = useState(false);
    const [chargesCollapsibleOpen, setChargesCollapsibleOpen] = useState(true);
    const [chargeInputs, setChargeInputs] = useState({});
    // Additional Charges contribution applied to the summary panel — populated
    // only when the user clicks Save in the Charges popup (see handleSaveCharges).
    const [chargesSummary, setChargesSummary] = useState({ total: 0, cgst: 0, sgst: 0, igst: 0 });

    // Restore chargeInputs and chargesSummary from initialData if provided (when loading an existing quotation)
    useEffect(() => {
        // API chargeInputs are already keyed by TransType (200, 201, 202, 203, 204)
        // which matches charge.TransType in additionalCharges, so no mapping needed
        if (initialData?.chargeInputs && Object.keys(initialData.chargeInputs).length > 0) {
            console.log('[ChargeInputs Debug] API chargeInputs keys:', Object.keys(initialData.chargeInputs));
            if (additionalCharges && additionalCharges.length > 0) {
                console.log('[ChargeInputs Debug] additionalCharges:', additionalCharges.map(c => ({ TransType: c.TransType, SrNo: c.SrNo, name: c.ChargeName })));
            }
            setChargeInputs(initialData.chargeInputs);
        }

        // Restore chargesSummary from charge rows in tableData (has actual calculated tax amounts)
        // This is more reliable since the API calculates taxes based on actual requirements
        if (initialData?.tableData) {
            const chargesTaxData = { total: 0, cgst: 0, sgst: 0, igst: 0 };

            initialData.tableData.forEach(row => {
                const transType = row.TransType != null ? parseInt(row.TransType) : 100;
                const isCharge = transType >= 200 && transType <= 204;
                if (isCharge) {
                    // Use the PRE-TAX amount from the charge row (not TaxableAmt which is tax-inclusive)
                    chargesTaxData.total += Number(row.amount || 0);
                    // Add the tax amounts from the charge row (already calculated by backend)
                    chargesTaxData.cgst += Number(row.CGSTAmt || 0);
                    chargesTaxData.sgst += Number(row.SGSTAmt || 0);
                    chargesTaxData.igst += Number(row.IGSTAmt || 0);
                }
            });

            console.log('[ChargesSummary Debug] Calculated from tableData:', chargesTaxData);

            if (chargesTaxData.total > 0 || chargesTaxData.cgst > 0 || chargesTaxData.sgst > 0 || chargesTaxData.igst > 0) {
                setChargesSummary(chargesTaxData);
            }
        }
        // Depend on the specific fields read above, not the whole initialData object —
        // initialData is a fresh object literal from the parent on every render
        // (formData.product || {}), so depending on it directly re-fires this effect
        // (and its setChargesSummary call) on every parent re-render, not just when
        // the actual saved charge data changes.
    }, [initialData?.chargeInputs, initialData?.tableData]);

    // Populate each charge slot's editable state (Amount, and Tax when TaxEnabled)
    // fresh every time the popup opens — default Tax is whatever was saved for
    // that slot in UserDefineColumns (charge.TaxId). Preserve amount if already restored from initialData.
    useEffect(() => {
        if (!chargesDialogOpen) return;
        setChargeInputs(prev => {
            const next = { ...prev };
            additionalCharges.forEach(charge => {
                const key = charge.TransType;
                if (!next[key]) {
                    // Only set empty amount if not already populated (e.g., from initialData restore)
                    next[key] = {
                        amount: '',
                        taxId: charge.TaxId ?? null,
                    };
                } else {
                    // Preserve existing amount, but update taxId to the configured one if not already set
                    if (next[key].taxId === null && charge.TaxId !== null) {
                        next[key].taxId = charge.TaxId;
                    }
                }
            });
            return next;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chargesDialogOpen, additionalCharges]);

    const updateChargeInput = (key, patch) => {
        setChargeInputs(prev => ({
            ...prev,
            [key]: { ...prev[key], ...patch },
        }));
    };
    const companyId = selectedCompany?.CompId || null;
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    // Apply normalization here
    const state = normalizeState(clientData?.details?.['State']);
    const compState = normalizeState(selectedCompany?.State);

    console.log('Normalized Client State:', state);
    console.log('Normalized Company State:', compState);
    console.log('Same State:', areSameState(clientData?.details?.['State'], selectedCompany?.State));

    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    console.log("hiii")

    const [rows, setRows] = useState([]);
    const [nextSrNo, setNextSrNo] = useState(1);
    const [current, setCurrent] = useState({ Id: '', productCode: '', description: '', UnitId: '', unit: '', qty: 1, rate: 0, disc: 0, tax: 0, MRP: 0, batchNo: '', expDate: '', serialNo: '', amount: '', taxAmount: '', remark: '', CGST: '0.00', SGST: '0.00', IGST: '0.00', UTGST: '0.00', GSTCess: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', TaxId: null, PONo: '', PODate: '', POQty: '', type: '', size: '', color: '', freeQty: '', per: '', pkg: '', oth1: '', oth2: '', oth3: '', gOth10: '0.00', poQty: '', ex4: '', ex5: '', exQty6: '', serialNo: '', oth4: '', oth5: '', oth6: '', oth7: '', TransType: 100 });
    const [totals, setTotals] = useState({ basic: 0, discount: 0, cgst: 0, sgst: 0, igst: 0, roundOff: 0, total: 0 });
    const [errors, setErrors] = useState({});
    const [editIndex, setEditIndex] = useState(null);
    const [allProducts, setAllProducts] = useState([]);
    const [unitOptions, setUnitOptions] = useState([]);
    const [colorMap, setColorMap] = useState({});
    const [sizeMap, setSizeMap] = useState({});
    const [isInitialized, setIsInitialized] = useState(false);
    const [gsts, setGsts] = useState([]);
    const API = connectionString;

    const requiredAsteriskStyle = {
        '& .MuiFormLabel-asterisk': {
            color: 'red',
        },
    };

    const API_BASE = `${connectionString}/api`;


    // Track if component has finished initializing
    const hasInitializedRef = useRef(false);

    // When true, the next run of the live-calculation effect is skipped —
    // set right before a row's DB values are loaded into `current` (editRow),
    // so entering edit mode doesn't immediately overwrite the stored amount.
    const skipNextCalcRef = useRef(false);

    // Ref to the Product Code field for auto-focus
    const productCodeRef = useRef(null);

    // Notify parent when rows change — but ONLY after initialization is done
    useEffect(() => {
        if (!hasInitializedRef.current) return; // Don't fire on first empty render
        if (onRowsChange) {
            onRowsChange(rows);
        }
    }, [rows]);

    // Reset isInitialized when coming back with data but rows are empty
    useEffect(() => {
        if (initialData?.tableData?.length && rows.length === 0 && hasInitializedRef.current) {
            setIsInitialized(false);
        }
    }, [initialData?.tableData]);

    // For add mode — no initialData, so mark as initialized immediately
    useEffect(() => {
        if (!initialData?.tableData?.length) {
            hasInitializedRef.current = true;
        }
    }, []);



    const transformGSTs = data =>
        Array.isArray(data)
            ? data.map(i => ({ Id: i.TaxID, value: i.Taxcode }))
            : [];

    const Hlp_Fn_GST = async () => {
        try {
            const { data } = await axios.get(`${API_BASE}/product-get-data/api/gst?companyId=${companyId}`);
            console.log(data)
            setGsts(transformGSTs(data));
        } catch (e) {
            console.error('GST lookup failed', e);
            setSnackbar({ open: true, message: 'GST lookup failed.', severity: 'error' });
            setGsts([]);
        }
    };

    useEffect(() => {
        Hlp_Fn_GST();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const unitsRes = await axios.get(`${API}/api/unit/retrive`, { params: { companyId } });
                console.log(unitsRes.data);
                setUnitOptions(unitsRes.data);
                const [cRes, sRes] = await Promise.all([
                    axios.get(`${API}/api/colormaster`),
                    axios.get(`${API}/api/sizemaster`)
                ]);
                const cm = {}, sm = {};
                cRes.data.forEach(c => (cm[c.colorId] = { name: c.itemColor, code: c.colorCode }));
                sRes.data.forEach(s => (sm[s.sizeId] = { name: s.itemSize, code: s.sizeCode }));
                setColorMap(cm);
                setSizeMap(sm);
            } catch (error) {
                console.error('Error fetching product or unit data:', error);
            }
        };

        fetchData();
        loadAllProducts();
    }, []);

    const handleProductAdded = async () => {
        // Reload units when product is added
        try {
            const unitsRes = await axios.get(`${connectionString}/api/unit/retrive`, {
                params: { companyId }
            });
            setUnitOptions(unitsRes.data);

            // Also reload products
            await loadAllProducts();
        } catch (error) {
            console.error('Error refreshing data:', error);
        }
    };

    const loadAllProducts = async () => {
        try {
            const res = await axios.get(`${API}/api/productdata/retrive`, { params: { companyId, mode: 'SALE' } });
            setAllProducts(res.data || []);
        } catch (e) {
            console.error('Error fetching products:', e);
        }
    };

    useEffect(() => {
        if (isInitialized || !initialData?.tableData || !Array.isArray(initialData.tableData) || !unitOptions.length || !allProducts.length) {
            return;
        }

        console.log("initialData.tableData", initialData.tableData)

        // Filter out roundOff rows (TransType=300, 200, 201, 202, 203, 204) for counting SrNo
        const regularRows = initialData.tableData.filter(r => r.TransType !== 200 && r.TransType !== 201 && r.TransType !== 202 && r.TransType !== 203 && r.TransType !== 204 && r.TransType !== 300);

        const initialRows = initialData.tableData.map((r, index) => {
            // Only count regular rows (exclude roundOff) for SrNo calculation
            const regularIndex = regularRows.findIndex(row => row === r);
            const srNoValue = (r.TransType === 300 || r.TransType === 200 || r.TransType === 201 || r.TransType === 202 || r.TransType === 203 || r.TransType === 204) ? 30000 : (regularRows.length - regularIndex);
            const qty = Number(r.qty) || 0;
            const rate = Number(r.rate) || 0;
            const disc = Number(r.disc) || 0;
            // Prefer the exact amount stored in the database over recomputing it —
            // recomputing here can silently diverge from what was actually saved.
            // Only fall back to qty*rate*(1-disc/100) when the DB has no stored amount.
            const storedAmt = r.TaxableAmt ?? r.amount;
            const hasStoredAmt = storedAmt != null && storedAmt !== '' && !Number.isNaN(Number(storedAmt));
            const taxableAmt = hasStoredAmt ? Number(storedAmt) : qty * rate * (1 - disc / 100);

            const product = allProducts.find(p => p.Id === r.productId || p.itemCode === r.productCode);
            let tax = Number(r.tax) || 0;
            let taxAmount = taxableAmt * (tax / 100);
            let cgst = '0.00', sgst = '0.00', igst = '0.00';
            let cgstAmt = '0.00', sgstAmt = '0.00', igstAmt = '0.00';
            let taxId = r.taxId || r.TaxId || null;

            // Use areSameState for comparison
            const isSameState = areSameState(state, compState);

            if (product) {
                tax = Number(r.tax) || 0;       //  backend value
                taxId = r.taxId || r.TaxId || null;        //  backend value
                taxAmount = taxableAmt * (tax / 100);
                cgst = isSameState ? (tax / 2).toFixed(2) : '0.00';
                sgst = isSameState ? (tax / 2).toFixed(2) : '0.00';
                igst = !isSameState ? tax.toFixed(2) : '0.00';
                cgstAmt = isSameState ? (taxAmount / 2).toFixed(2) : '0.00';
                sgstAmt = isSameState ? (taxAmount / 2).toFixed(2) : '0.00';
                igstAmt = !isSameState ? taxAmount.toFixed(2) : '0.00';
            } else {
                taxAmount = taxableAmt * (tax / 100);
                cgst = Number(r.CGST || (isSameState ? (tax / 2) : 0)).toFixed(2);
                sgst = Number(r.SGST || (isSameState ? (tax / 2) : 0)).toFixed(2);
                igst = Number(r.IGST || (!isSameState ? tax : 0)).toFixed(2);
                cgstAmt = Number(r.CGSTAmt || (isSameState ? (taxAmount / 2) : 0)).toFixed(2);
                sgstAmt = Number(r.SGSTAmt || (isSameState ? (taxAmount / 2) : 0)).toFixed(2);
                igstAmt = Number(r.IGSTAmt || (!isSameState ? taxAmount : 0)).toFixed(2);
            }

            const matchedUnit = unitOptions.find(u => String(u.UnitId) === String(r.UnitId)) || unitOptions.find(u => String(u.UnitId) === String(r.unit)) || unitOptions.find(u => u.unit?.toLowerCase() === String(r.unit).toLowerCase());

            return { ...r, remark: typeof r.remark === "string" && r.remark.trim() !== r.description?.trim() ? r.remark : "", productId: r.productId || r.Id || r.id || '', UnitId: matchedUnit ? String(matchedUnit.UnitId) : r.UnitId || '', unit: matchedUnit ? matchedUnit.unit : r.unit || '', qty, rate, disc, tax, TaxableAmt: taxableAmt.toFixed(2), taxAmount: Number(r.taxAmount) || taxAmount.toFixed(2), amount: taxableAmt.toFixed(2), CGST: cgst, SGST: sgst, IGST: igst, CGSTAmt: cgstAmt, SGSTAmt: sgstAmt, IGSTAmt: igstAmt, UTGST: String(r.UTGST || '0.00'), GSTCess: String(r.GSTCess || '0.00'), TaxId: taxId, srNo: srNoValue };
        });

        setRows(initialRows);
        setNextSrNo(initialRows.length + 1);
        setIsInitialized(true);
        hasInitializedRef.current = true; // ← for lifting rows state up 
    }, [initialData?.tableData, unitOptions, allProducts, state, compState, isInitialized]);

    useEffect(() => {
        // `current` was just loaded from a saved row (editRow) — skip this one
        // pass so the DB-stored amount isn't immediately overwritten before the
        // user has actually changed anything.
        if (skipNextCalcRef.current) {
            skipNextCalcRef.current = false;
            return;
        }

        const qty = Number(current.qty) || 0;
        const rate = Number(current.rate) || 0;
        const disc = Number(current.disc) || 0;
        const tax = Number(current.tax) || 0;
        const taxableAmt = getAmountCalcSafe(qty, rate, current.pkg, disc, isApplyPkgInAmtEnabled, calculateAmount).taxable;
        const taxAmount = taxableAmt * (tax / 100);

        // Use areSameState for comparison
        const isSameState = areSameState(state, compState);

        setCurrent(prev => ({
            ...prev,
            TaxableAmt: taxableAmt.toFixed(2),
            amount: taxableAmt.toFixed(2),
            taxAmount: taxAmount.toFixed(2),
            CGST: isSameState ? (tax / 2).toFixed(2) : '0.00',
            SGST: isSameState ? (tax / 2).toFixed(2) : '0.00',
            IGST: !isSameState ? tax.toFixed(2) : '0.00',
            CGSTAmt: isSameState ? (taxAmount / 2).toFixed(2) : '0.00',
            SGSTAmt: isSameState ? (taxAmount / 2).toFixed(2) : '0.00',
            IGSTAmt: !isSameState ? taxAmount.toFixed(2) : '0.00'
        }));
    }, [current.qty, current.rate, current.pkg, current.disc, current.tax, state, compState, isApplyPkgInAmtEnabled, calculateAmount]);

    // useEffect(() => {
    //     setIsInitialized(false);
    // }, [initialData]);

    useEffect(() => {
        const n = v => Number(v || 0);
        const isSameState = state?.toLowerCase() === compState?.toLowerCase();

        let basicAmountSum = 0;
        let discountTotal = 0;
        let cgstTotal = 0;
        let sgstTotal = 0;
        let igstTotal = 0;

        rows.forEach(r => {
            // Only include normal product rows (TransType 100) in totals
            // Exclude Additional Charges (TransType 200-204) and RoundOff (TransType 300)
            const transType = r.TransType != null ? parseInt(r.TransType) : 100;
            const isNormalProduct = transType === 100;
            if (!isNormalProduct) return;

            const qty = n(r.qty);
            const rate = n(r.rate);
            const gross = qty * rate;
            const taxable = n(r.amount || r.TaxableAmt);
            const discAmtRow = n(r.DiscAmt) || Math.max(0, gross - taxable);
            const taxPct = n(r.tax);

            const cgstAmtRow = (r.CGSTAmt != null && r.CGSTAmt !== '') ? n(r.CGSTAmt) : (isSameState ? taxable * (taxPct / 100) / 2 : 0);
            const sgstAmtRow = (r.SGSTAmt != null && r.SGSTAmt !== '') ? n(r.SGSTAmt) : (isSameState ? taxable * (taxPct / 100) / 2 : 0);
            const igstAmtRow = (r.IGSTAmt != null && r.IGSTAmt !== '') ? n(r.IGSTAmt) : (isSameState ? 0 : taxable * (taxPct / 100));

            basicAmountSum += taxable;
            discountTotal += discAmtRow;
            cgstTotal += cgstAmtRow;
            sgstTotal += sgstAmtRow;
            igstTotal += igstAmtRow;
        });

        const totalTax = cgstTotal + sgstTotal + igstTotal;
        // Fold Additional Charges (amount + their own GST) into the pre-rounding
        // amount so Round Off reflects the actual payable total, not just products.
        const chargesTotal = Number(chargesSummary.total || 0)
            + Number(chargesSummary.cgst || 0)
            + Number(chargesSummary.sgst || 0)
            + Number(chargesSummary.igst || 0);
        const finalAmount = basicAmountSum + totalTax + chargesTotal;

        // const roundedFinal = Math.ceil(finalAmount);
        // const roundOff = Number((roundedFinal - finalAmount).toFixed(2));

        const decimalPart = finalAmount - Math.floor(finalAmount);

        const roundedFinal =
            decimalPart >= 0.5
                ? Math.ceil(finalAmount)
                : Math.floor(finalAmount);

        const roundOff = Number((roundedFinal - finalAmount).toFixed(2));


        setTotals({
            basic: basicAmountSum.toFixed(2),
            discount: discountTotal.toFixed(2),
            cgst: cgstTotal.toFixed(2),
            sgst: sgstTotal.toFixed(2),
            igst: igstTotal.toFixed(2),
            roundOff: roundOff.toFixed(2),
            total: roundedFinal.toFixed(2)
        });
    }, [rows, state, compState, chargesSummary]);

    // Additional Charges: given a charge and its current popup input, compute
    // the charge amount, the tax on it (only when TaxEnabled), and the final
    // (tax-inclusive) amount — this is what "Final Amount" displays live.
    const getChargeFinalAmounts = (charge, input) => {
        const chargeAmount = Number(input?.amount) || 0;
        if (!charge.TaxEnabled) {
            return { chargeAmount, taxPercent: 0, taxAmount: 0, finalAmount: chargeAmount };
        }
        const selectedGST = gsts.find(g => String(g.Id) === String(input?.taxId));
        const taxPercent = parseFloat(selectedGST?.value) || 0;
        const taxAmount = chargeAmount * taxPercent / 100;
        return { chargeAmount, taxPercent, taxAmount, finalAmount: chargeAmount + taxAmount };
    };

    // Sync chargesSummary with chargeInputs whenever chargeInputs changes
    // This ensures that when chargeInputs are restored from initialData,
    // chargesSummary is recalculated with the correct tax values
    useEffect(() => {
        const isSameState = state?.toLowerCase() === compState?.toLowerCase();
        let addTotal = 0, addCgst = 0, addSgst = 0, addIgst = 0;
        additionalCharges.forEach(charge => {
            const key = charge.TransType;
            const input = chargeInputs[key];
            if (!input || !input.amount) return;
            const amount = Number(input.amount) || 0;
            const { taxAmount } = getChargeFinalAmounts(charge, input);
            addTotal += amount;
            if (charge.TaxEnabled) {
                if (isSameState) {
                    addCgst += taxAmount / 2;
                    addSgst += taxAmount / 2;
                } else {
                    addIgst += taxAmount;
                }
            }
        });
        setChargesSummary({ total: addTotal, cgst: addCgst, sgst: addSgst, igst: addIgst });
    }, [chargeInputs, additionalCharges, state, compState, gsts]);

    // Additional Charges: on Save, fold every charge's final amount into the
    // Total Amount shown in the summary, and its tax (if any) into CGST+SGST
    // (same state) or IGST (different state) — same split rule the totals
    // useEffect already uses for product rows.
    const handleSaveCharges = () => {
        const isSameState = state?.toLowerCase() === compState?.toLowerCase();
        let addTotal = 0, addCgst = 0, addSgst = 0, addIgst = 0;
        console.log('[handleSaveCharges] Starting calculation. isSameState:', isSameState);
        console.log('[handleSaveCharges] chargeInputs:', chargeInputs);
        additionalCharges.forEach(charge => {
            const key = charge.TransType;
            const input = chargeInputs[key];
            if (!input || !input.amount) {
                console.log('[handleSaveCharges] Skipping charge', key, '- no input or amount');
                return;
            }
            const amount = Number(input.amount) || 0;
            const { taxAmount, finalAmount } = getChargeFinalAmounts(charge, input);
            console.log('[handleSaveCharges] Charge', key, '- amount:', amount, 'taxAmount:', taxAmount, 'finalAmount:', finalAmount, 'TaxEnabled:', charge.TaxEnabled);
            // chargesSummary.total should be sum of PRE-TAX amounts, not final amounts
            addTotal += amount;
            if (charge.TaxEnabled) {
                if (isSameState) {
                    addCgst += taxAmount / 2;
                    addSgst += taxAmount / 2;
                } else {
                    addIgst += taxAmount;
                }
            }
        });
        console.log('[handleSaveCharges] Final summary - total:', addTotal, 'cgst:', addCgst, 'sgst:', addSgst, 'igst:', addIgst);
        setChargesSummary({ total: addTotal, cgst: addCgst, sgst: addSgst, igst: addIgst });
        setChargesDialogOpen(false);
    };

    const handleChange = field => e => {
        if (field === 'UnitId') {
            const selectedUnit = unitOptions.find(u => u.UnitId === Number(e.target.value));
            setCurrent(prev => ({
                ...prev,
                UnitId: e.target.value,
                unit: selectedUnit ? selectedUnit.unit : ''
            }));
        } else {
            setCurrent(prev => ({ ...prev, [field]: e.target.value }));
        }
    };




    const handleSelect = async product => {
        const matchedUnit = unitOptions.find(opt => {
            if (product.UnitId && opt.UnitId === product.UnitId) return true;
            if (product.Unit && opt.unit?.toLowerCase() === product.Unit.toLowerCase()) return true;
            if (product.unit && opt.unit?.toLowerCase() === product.unit.toLowerCase()) return true;
            return false;
        });

        const isSameState = areSameState(state, compState);

        const qty = 1;
        let rate = Number(product.Rate) || 0;
        let disc = Number(product.Discount) || 0;
        let MRP = Number(product.MRP) || 0;

        // Fetch Last Sale Rate if enabled
        if (isLastSaleRateEnabled) {
            console.log('💾 EnquiryModule_v1: Fetching last sale rate for product:', product.Id, 'party:', clientData?.clientId);
            const lastSaleData = await getLastSaleRate(product.Id, clientData?.clientId);
            if (lastSaleData.rate !== null) {
                rate = lastSaleData.rate;
                console.log('✅ EnquiryModule_v1: Last sale rate fetched:', rate);
            }
            if (lastSaleData.disc !== null) {
                disc = lastSaleData.disc;
                console.log('✅ EnquiryModule_v1: Last sale disc fetched:', disc);
            }
        }

        const tax = parseFloat(product.GST) || 0;
        const taxId = product.TaxId || null;

        // If "Apply MRP in Sale?" is enabled and product has MRP, calculate rate from MRP
        if (isApplyMRPInSaleEnabled && MRP > 0) {
            console.log('🏷️ EnquiryModule_v1: Apply MRP in Sale enabled. Calculating rate from MRP:', MRP);
            rate = calculateSaleRateFromMRP(MRP, tax);
        }

        const taxableAmt = qty * rate * (1 - disc / 100);
        const taxAmount = taxableAmt * (tax / 100);

        setCurrent({
            Id: product.Id?.toString() || '',
            productCode: product.itemCode || '',
            description: product.description || '',
            UnitId: matchedUnit ? String(matchedUnit.UnitId) : '',
            unit: matchedUnit ? matchedUnit.unit : '',
            qty,
            rate,
            disc,
            tax,
            MRP,
            batchNo: '',
            expDate: '',
            serialNo: '',
            amount: taxableAmt.toFixed(2),
            taxAmount: taxAmount.toFixed(2),
            remark: '',
            TaxId: taxId,
            CGST: isSameState ? (tax / 2).toFixed(2) : '0.00',
            SGST: isSameState ? (tax / 2).toFixed(2) : '0.00',
            IGST: !isSameState ? tax.toFixed(2) : '0.00',
            UTGST: '0.00',
            GSTCess: '0.00',
            CGSTAmt: isSameState ? (taxAmount / 2).toFixed(2) : '0.00',
            SGSTAmt: isSameState ? (taxAmount / 2).toFixed(2) : '0.00',
            IGSTAmt: !isSameState ? taxAmount.toFixed(2) : '0.00',
            TaxableAmt: taxableAmt.toFixed(2),
            PONo: '',
            PODate: '',
            POQty: '',
            type: '',
            size: '',
            color: '',
            freeQty: '',
            per: '',
            pkg: '',
            oth1: '',
            oth2: '',
            oth3: '',
            gOth10: '0.00',
            poQty: '',
            ex4: '',
            ex5: '',
            exQty6: '',
            serialNo: '',
            oth4: '',
            oth5: '',
            oth6: '',
            oth7: ''
        });
        // setEditIndex(null);
        setErrors({});
    };

    const addProduct = () => {
        const errs = {};
        const messages = new Set();
        const requiredFields = ['productCode', 'description', 'UnitId', 'qty', 'rate', 'tax'];

        // GST validation
        if (!current.TaxId) {
            errs.TaxId = true;
            messages.add('Please select GST before adding product.');
        }

        requiredFields.forEach(field => {
            if (!current[field] && current[field] !== 0) {
                errs[field] = 'Required';
                messages.add('All fields are required.');
            }
        });

        if (!current.qty || Number(current.qty) <= 0) {
            errs.qty = 'Must be > 0';
            messages.add('Qty must be greater than 0');
        }

        if (!current.rate || current.rate <= 0) {
            errs.rate = 'Rate must be greater than 0';
            messages.add('Rate must be greater than 0');
        }

        if (current.disc < 0) {
            errs.disc = 'Cannot be negative';
            messages.add('Discount cannot be negative');
        }

        if (current.disc > 100) {
            errs.disc = 'Cannot be more than 100';
            messages.add('Discount cannot be more than 100');
        }

        if (messages.size > 0) {
            errs.global = Array.from(messages);
            setErrors(errs);
            return;
        }



        const safeQty = current.qty === '' || current.qty == null ? 1 : Number(current.qty);
        const safeDisc = current.disc === '' || current.disc == null ? 0 : Number(current.disc);

        const isSameState = areSameState(state, compState);

        // const qty = Number(current.qty) || 0;
        const qty = safeQty;
        const rate = Number(current.rate) || 0;
        // const disc = Number(current.disc) || 0;
        const disc = safeDisc;
        const tax = Number(current.tax) || 0;
        const taxableAmt = getAmountCalcSafe(qty, rate, current.pkg, disc, isApplyPkgInAmtEnabled, calculateAmount).taxable;
        const taxAmount = taxableAmt * (tax / 100);

        const row = {
            ...current,
            productId: current.Id,
            qty,
            rate,
            disc,
            tax,
            remark: current.remark?.trim() !== '' ? current.remark : '',
            TaxableAmt: taxableAmt.toFixed(2),
            taxAmount: taxAmount.toFixed(2),
            amount: taxableAmt.toFixed(2),
            CGST: isSameState ? (tax / 2).toFixed(2) : '0.00',
            SGST: isSameState ? (tax / 2).toFixed(2) : '0.00',
            IGST: !isSameState ? tax.toFixed(2) : '0.00',
            CGSTAmt: isSameState ? (taxAmount / 2).toFixed(2) : '0.00',
            SGSTAmt: isSameState ? (taxAmount / 2).toFixed(2) : '0.00',
            IGSTAmt: !isSameState ? taxAmount.toFixed(2) : '0.00',
            UTGST: current.UTGST,
            GSTCess: current.GSTCess,
            TaxId: current.TaxId,
            srNo: editIndex != null ? rows[editIndex].srNo : nextSrNo,
            TransType: current.TransType || 100
        };

        const existingRowIndex = rows.findIndex(
            (r, i) => r.productCode === current.productCode && i !== editIndex
        );

        // if (existingRowIndex !== -1 && editIndex == null) {
        //     setRows(prev =>
        //         prev.map((r, i) => {
        //             if (i === existingRowIndex) {
        //                 const newQty = Number(r.qty) + qty;
        //                 const newTaxableAmt = newQty * rate * (1 - disc / 100);
        //                 const newTaxAmount = newTaxableAmt * (tax / 100);
        //                 return {
        //                     ...r,
        //                     qty: newQty,
        //                     rate,
        //                     disc,
        //                     tax,
        //                     remark: current.remark?.trim() !== '' ? current.remark : '',
        //                     TaxableAmt: newTaxableAmt.toFixed(2),
        //                     taxAmount: newTaxAmount.toFixed(2),
        //                     amount: newTaxableAmt.toFixed(2),
        //                     CGST: isSameState ? (tax / 2).toFixed(2) : '0.00',
        //                     SGST: isSameState ? (tax / 2).toFixed(2) : '0.00',
        //                     IGST: !isSameState ? tax.toFixed(2) : '0.00',
        //                     CGSTAmt: isSameState ? (newTaxAmount / 2).toFixed(2) : '0.00',
        //                     SGSTAmt: isSameState ? (newTaxAmount / 2).toFixed(2) : '0.00',
        //                     IGSTAmt: !isSameState ? newTaxAmount.toFixed(2) : '0.00',
        //                     UTGST: current.UTGST,
        //                     GSTCess: current.GSTCess,
        //                     TaxId: current.TaxId
        //                 };
        //             }
        //             return r;
        //         })
        //     );
        // } else {
        //     if (editIndex != null) {
        //         setRows(prev => prev.map((r, i) => (i === editIndex ? row : r)));
        //     } else {
        //         setRows(prev => [row, ...prev]);
        //         setNextSrNo(prev => prev + 1);
        //     }
        // }

        if (editIndex != null) {
            setRows(prev => prev.map((r, i) => i === editIndex ? { ...row, srNo: rows[editIndex].srNo } : r));
        } else {
            setRows(prev => [row, ...prev]);
            setNextSrNo(prev => prev + 1);
        }

        setCurrent({ Id: '', productCode: '', description: '', UnitId: '', unit: '', qty: 1, rate: 0, disc: 0, tax: 0, MRP: 0, remark: '', CGST: '0.00', SGST: '0.00', IGST: '0.00', UTGST: '0.00', GSTCess: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', taxAmount: '', amount: '', TaxId: null, batchNo: '', expDate: '', serialNo: '', PONo: '', PODate: '', POQty: '', type: '', size: '', color: '', freeQty: '', per: '', pkg: '', oth1: '', oth2: '', oth3: '', gOth10: '0.00', poQty: '', ex4: '', ex5: '', exQty6: '', serialNo: '', oth4: '', oth5: '', oth6: '', oth7: '', TransType: 100 });
        setErrors({});
        setEditIndex(null);

        // Focus on Product Code field after adding product (not after updating)
        if (editIndex == null) {
            setTimeout(() => {
                productCodeRef.current?.focus?.();
            }, 0);
        }
    };

    const editRow = idx => {

        if (isLocked) return;

        const row = rows[idx];
        const matchedUnit = unitOptions.find(u => String(u.UnitId) === String(row.UnitId)) || unitOptions.find(u => String(u.UnitId) === String(row.unit)) || unitOptions.find(u => u.unit?.toLowerCase() === String(row.unit).toLowerCase());

        console.log("EDIT ROW DATA:", row);

        // This row's Qty/Rate/Pkg/Disc are about to be loaded into `current` from
        // the DB values — skip the next live-calculation pass so it doesn't
        // immediately overwrite the stored amount before the user edits anything.
        skipNextCalcRef.current = true;

        setCurrent({
            ...row,
            Id: row.productId,
            UnitId: matchedUnit ? String(matchedUnit.UnitId) : row.UnitId || '',
            unit: matchedUnit ? matchedUnit.unit : row.unit || '',
            CGST: String(row.CGST || '0.00'),
            SGST: String(row.SGST || '0.00'),
            IGST: String(row.IGST || '0.00'),
            CGSTAmt: String(row.CGSTAmt || '0.00'),
            SGSTAmt: String(row.SGSTAmt || '0.00'),
            IGSTAmt: String(row.IGSTAmt || '0.00'),
            UTGST: String(row.UTGST || '0.00'),
            GSTCess: String(row.GSTCess || '0.00'),
            TaxableAmt: String(row.TaxableAmt || '0.00'),
            taxAmount: String(row.taxAmount || '0.00'),
            amount: String(row.amount || '0.00'),
            TaxId: row.TaxId ?? null,
            tax: row.tax ?? 0,
        });
        setEditIndex(idx);
    };

    const deleteRow = idx => {
        setRows(prev => prev.filter((_, i) => i !== idx));

        setCurrent({
            Id: '',
            productCode: '',
            description: '',
            UnitId: '',
            unit: '',
            qty: 1,
            rate: 0,
            disc: 0,
            tax: 0,
            remark: '',
            CGST: '0.00',
            SGST: '0.00',
            IGST: '0.00',
            UTGST: '0.00',
            GSTCess: '0.00',
            CGSTAmt: '0.00',
            SGSTAmt: '0.00',
            IGSTAmt: '0.00',
            TaxableAmt: '0.00',
            taxAmount: '',
            amount: '',
            TaxId: null,
            batchNo: '',
            expDate: '',
            serialNo: '',
            PONo: '',
            PODate: '',
            POQty: '',
            type: '',
            size: '',
            color: '',
            freeQty: '',
            per: '',
            pkg: '',
            oth1: '',
            oth2: '',
            oth3: '',
            gOth10: '0.00',
            poQty: '',
            ex4: '',
            ex5: '',
            exQty6: '',
            serialNo: '',
            oth4: '',
            oth5: '',
            oth6: '',
            oth7: '',
            TransType: 100
        });
        setEditIndex(null);
        setErrors({});
    };

    const handleNext = () => {


        if (rows.length === 0) {
            setErrors({ global: 'Add at least one product' });
            return;
        }

        const isSameState = areSameState(state, compState);

        // Filter out old charge rows (TransType 200-204, 300) — they'll be replaced by additionalChargeItems
        const regularRows = rows.filter(r => {
            const transType = r.TransType != null ? parseInt(r.TransType) : 100;
            return transType === 100; // Only keep normal product rows
        });

        const payloadRows = regularRows.map(r => {
            const qty = Number(r.qty) || 0;
            const rate = Number(r.rate) || 0;
            const gross = qty * rate;
            const taxable = Number(r.amount || r.TaxableAmt) || 0;
            const discAmt = Number(r.DiscAmt) || Math.max(0, gross - taxable);
            const matchedGST = gsts.find(g => String(g.Id) === String(r.TaxId));

            const taxPct = matchedGST
                ? (matchedGST.value?.toLowerCase().includes('tax free') ? 0 : parseFloat(matchedGST.value) || 0)
                : Number(r.tax) || 0;

            const taxAmt = Number(r.taxAmount) || (taxable * (taxPct / 100));

            const cgstAmt = (r.CGSTAmt != null && r.CGSTAmt !== '') ? Number(r.CGSTAmt) : (isSameState ? taxAmt / 2 : 0);
            const sgstAmt = (r.SGSTAmt != null && r.SGSTAmt !== '') ? Number(r.SGSTAmt) : (isSameState ? taxAmt / 2 : 0);
            const igstAmt = (r.IGSTAmt != null && r.IGSTAmt !== '') ? Number(r.IGSTAmt) : (!isSameState ? taxAmt : 0);

            return {
                productId: r.productId,
                productCode: r.productCode,
                description: r.description,
                unit: r.unit,
                UnitId: Number(r.UnitId) || null,
                qty,
                rate,
                MRP: Number(r.MRP) || 0,
                disc: Number(r.disc) || 0,
                tax: taxPct,
                batchNo: r.batchNo || '',
                expDate: r.expDate || null,
                serialNo: r.serialNo || '',
                remark: r.remark?.trim() !== '' ? r.remark : '',
                gross: Number(gross.toFixed(2)),
                amount: Number(taxable.toFixed(2)),
                TaxableAmt: Number(taxable.toFixed(2)),
                DiscAmt: Number(discAmt.toFixed(2)),
                taxAmount: Number(taxAmt.toFixed(2)),
                srNo: r.srNo,
                TransType: r.TransType || 100,
                TaxId: r.TaxId || null,
                CGST: isSameState ? Number((taxPct / 2).toFixed(2)) : 0,
                SGST: isSameState ? Number((taxPct / 2).toFixed(2)) : 0,
                IGST: isSameState ? 0 : Number(taxPct.toFixed(2)),
                CGSTAmt: Number(cgstAmt.toFixed(2)),
                SGSTAmt: Number(sgstAmt.toFixed(2)),
                IGSTAmt: Number(igstAmt.toFixed(2)),
                UTGST: r.UTGST || '0.00',
                GSTCess: r.GSTCess || '0.00',
                GSTOth: r.GSTOth || '0.00',
                PONo: r.PONo || null,
                PODate: r.PODate || null,
                poQty: r.poQty || null,
                ex4: r.ex4 || null,
                ex5: r.ex5 || null,
                exQty6: r.exQty6 || null,
                type: r.type || null,
                size: r.size || null,
                color: r.color || null,
                freeQty: r.freeQty || null,
                per: r.per || null,
                pkg: r.pkg || null,
                oth1: r.oth1 || null,
                oth2: r.oth2 || null,
                oth3: r.oth3 || null,
                oth4: r.oth4 || null,
                oth5: r.oth5 || null,
                oth6: r.oth6 || null,
                oth7: r.oth7 || null,
            };
        });

        const totalBasic = payloadRows.reduce((sum, r) => sum + (Number(r.amount) || 0), 0);
        const discountAmt = payloadRows.reduce((sum, r) => sum + (Number(r.DiscAmt) || 0), 0);
        const cgst = payloadRows.reduce((sum, r) => sum + (Number(r.CGSTAmt) || 0), 0);
        const sgst = payloadRows.reduce((sum, r) => sum + (Number(r.SGSTAmt) || 0), 0);
        const igst = payloadRows.reduce((sum, r) => sum + (Number(r.IGSTAmt) || 0), 0);

        const totalTax = cgst + sgst + igst;
        // Fold Additional Charges (amount + their own GST) into the pre-rounding
        // amount so Round Off reflects the actual payable total, not just products.
        const chargesTotal = Number(chargesSummary.total || 0)
            + Number(chargesSummary.cgst || 0)
            + Number(chargesSummary.sgst || 0)
            + Number(chargesSummary.igst || 0);
        const finalAmount = totalBasic + totalTax + chargesTotal;

        // const roundedFinal = Math.ceil(finalAmount);
        // const roundOff = Number((roundedFinal - finalAmount).toFixed(2));

        const decimalPart = finalAmount - Math.floor(finalAmount);

        const roundedFinal =
            decimalPart >= 0.5
                ? Math.ceil(finalAmount)
                : Math.floor(finalAmount);

        const roundOff = Number((roundedFinal - finalAmount).toFixed(2));

        // Additional Charges: charges saved in UserDefineColumns with ColToBeAsk=1
        // (i.e. present in `additionalCharges`, sourced from UserDefineContext) are
        // folded into the invoice payload — Adc{SrNo}Amt/Adc{SrNo}TaxId in summary
        // for all 5 fixed slots, plus one pseudo item row per SELECTED charge
        // (TransType 200-204, SrNo 20000-20004) appended to tableData.
        // When a charge's Tax is disabled, its TaxId is resolved to the taxmaster
        // row where GST = 0 (found via gsts, whose `value` doubles as the % — same
        // pattern already used elsewhere in this file, e.g. parseFloat(opt.value)).
        const zeroTaxId = gsts.find(g => parseFloat(g.value) === 0)?.Id ?? null;

        const additionalChargeSummary = {};
        const additionalChargeItems = [];
        for (let slot = 1; slot <= 5; slot++) {
            const charge = additionalCharges.find(c => Number(c.SrNo) === slot);
            if (!charge) {
                additionalChargeSummary[`Adc${slot}Amt`] = 0;
                additionalChargeSummary[`Adc${slot}TaxId`] = null;
                continue;
            }
            const key = charge.TransType;
            const input = chargeInputs[key] || { amount: '', taxId: charge.TaxId ?? null };
            const { taxPercent, taxAmount, finalAmount: chargeFinalAmount } = getChargeFinalAmounts(charge, input);
            const amount = Number(input.amount) || 0;
            const taxId = charge.TaxEnabled ? (input.taxId ?? null) : zeroTaxId;

            // saleinvoicemaster.AdcNAmt stores the charge's own pre-tax amount (e.g.
            // 100), not the tax-inclusive finalAmount (118) — AdcNTaxId is the tax used.
            additionalChargeSummary[`Adc${slot}Amt`] = amount;
            additionalChargeSummary[`Adc${slot}TaxId`] = taxId;

            // The item row (saleinvoicedetails) mirrors a normal product row's tax
            // breakdown: CGST/SGST/IGST hold the % rate, CGSTAmt/SGSTAmt/IGSTAmt hold
            // the tax amounts, and TaxableAmt holds the tax-inclusive final amount
            // (e.g. 100 + 18% tax = 118) — same CGST/SGST/IGST split this file already
            // uses for regular rows (isSameState → CGST+SGST split, else IGST).
            // productId — same field name/purpose as a normal row's productId, here
            // pointing at this slot's fixed charge-item (productmaster.Id via
            // userdefinecharges.ItemId, resolved from UserDefineContext).
            const chargeItemId = getChargeItemId(slot);
            additionalChargeItems.push({
                Id: chargeItemId,
                productId: chargeItemId,
                productCode: charge.ChargeName || '',
                description: charge.ChargeName || '',
                UnitId: null,
                unit: '',
                qty: 1,
                rate: amount,
                disc: 0,
                tax: Number(taxPercent.toFixed(2)),
                batchNo: '',
                expDate: null,
                serialNo: '',
                amount: amount,
                taxAmount: Number(taxAmount.toFixed(2)),
                remark: '',
                TaxId: taxId,
                CGST: isSameState ? Number((taxPercent / 2).toFixed(2)) : 0,
                SGST: isSameState ? Number((taxPercent / 2).toFixed(2)) : 0,
                IGST: isSameState ? 0 : Number(taxPercent.toFixed(2)),
                UTGST: '0.00',
                GSTCess: '0.00',
                GSTOth: '0.00',
                GSTEduCess: '0.00',
                GSTEducessAmt: '0.00',
                CGSTAmt: isSameState ? Number((taxAmount / 2).toFixed(2)) : 0,
                SGSTAmt: isSameState ? Number((taxAmount / 2).toFixed(2)) : 0,
                IGSTAmt: isSameState ? 0 : Number(taxAmount.toFixed(2)),
                GSTCEssAmt: '0.00',
                TaxableAmt: Number(chargeFinalAmount.toFixed(2)),
                challanDtsID: null,
                challanID: null,
                soId: null,
                soDtsID: null,
                PONo: null,
                PODate: null,
                poQty: null,
                type: null,
                size: null,
                color: null,
                freeQty: null,
                per: null,
                pkg: null,
                oth1: null,
                oth2: null,
                oth3: null,
                oth4: null,
                oth5: null,
                oth6: null,
                oth7: null,
                ex4: null,
                ex5: null,
                exQty6: null,
                serialNo: '',
                configData: [],
                _isNew: true,
                configType: null,
                applyBatchNo: 0,
                applySerialNo: 0,
                warrantyMonths: null,
                expiryDays: null,
                srNo: 19999 + slot,
                dispQty: 0,
                gross: amount,
                DiscAmt: 0,
                refNo: null,
                refDate: null,
                refQty: null,
                oth1Amt: null,
                oth2Amt: null,
                oth3Amt: null,
                oth4Amt: null,
                oth5Amt: null,
                oth6Amt: null,
                oth7Amt: null,
                // Fixed identifiers driving the backend's TransType-aware SrNo
                // override (see dispatchController.js / saleInvoiceController.js).
                SrNo: 19999 + slot,
                TransType: 199 + slot,
            });
        }

        const payload = {
            tableData: [...payloadRows, ...additionalChargeItems],
            summary: {
                basic: Number(totalBasic.toFixed(2)),
                discount: Number(discountAmt.toFixed(2)),
                cgst: Number(cgst.toFixed(2)) + Number(chargesSummary.cgst || 0),
                sgst: Number(sgst.toFixed(2)) + Number(chargesSummary.sgst || 0),
                igst: Number(igst.toFixed(2)) + Number(chargesSummary.igst || 0),
                roundOff: Number(roundOff.toFixed(2)),
                total: Number(roundedFinal.toFixed(2)),
                ...additionalChargeSummary
            },
            chargeInputs: chargeInputs
        };



        onNext(payload);
    };

    const formatINR = val => {
        const num = Number(val) || 0;
        return num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const columns = [
        { field: 'srNo', headerName: '#', width: 40, align: 'center', headerAlign: 'center' },
        {
            field: 'product', headerName: 'Product', flex: 1, sortable: false, filterable: false,
            renderCell: params => {
                const { productCode, description, unit, tax, batchNo, expDate, serialNo, remark, CGSTAmt, SGSTAmt, IGSTAmt } = params.row;
                // const matchedGST = gsts.find(g => String(g.Id) === String(params.row.TaxId));
                // const displayTax = matchedGST
                //     ? (matchedGST.value?.toLowerCase().includes('tax free') ? '0%' : matchedGST.value)
                //     : (!params.row.tax || Number(params.row.tax) === 0
                //         ? '0%'
                //         : `${params.row.tax}%`);
                const isSameState = areSameState(state, compState);

                return (
                    <Box sx={{ py: 0.5, display: 'flex', flexDirection: 'column' }}>
                        <Box>
                            <Typography variant="body2" fontWeight="bold" component="div"
                                sx={{
                                    cursor: isLocked ? "not-allowed" : "pointer",
                                    color: isLocked ? "#999" : "#1877F2",
                                    textDecoration: isLocked ? "none" : "underline",
                                    fontSize: "0.85rem",
                                    opacity: isLocked ? 0.6 : 1
                                }}
                                onClick={e => {
                                    e.stopPropagation();
                                    editRow(params.row.index);
                                }}
                            >
                                {productCode}
                            </Typography>
                            <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.85rem' }}>
                                {description}
                            </Typography>
                        </Box>
                        {(isColVisible(COL.UNIT) || isColVisible(COL.TAX_CODE)) && (
                            <Typography variant="caption" display="block">
                                {isColVisible(COL.UNIT) && `Unit: ${unit || 'N/A'}`}
                                {isColVisible(COL.UNIT) && isColVisible(COL.TAX_CODE) && ' | '}
                                {isColVisible(COL.TAX_CODE) && `GST: ${tax}%`}
                            </Typography>
                        )}
                        {(isSameState ? (isColVisible(COL.UTGST) || isColVisible(COL.UTGST)) : isColVisible(COL.UTGST)) && (
                            <Typography variant="caption" display="block" color="text.secondary">
                                {isSameState
                                    ? [
                                        isColVisible(COL.UTGST) && `SGST: ₹${formatINR(SGSTAmt)}`,
                                        isColVisible(COL.UTGST) && `CGST: ₹${formatINR(CGSTAmt)}`,
                                    ].filter(Boolean).join(' + ')
                                    : `IGST: ₹${formatINR(IGSTAmt)}`}
                            </Typography>
                        )}
                        {((batchNo && isColVisible(COL.BATCH_NO)) || (expDate && isColVisible(COL.EXP_DATE)) || serialNo) && (
                            <Typography variant="caption" display="block">
                                {batchNo && isColVisible(COL.BATCH_NO) && `Batch: ${batchNo}`}
                                {expDate && isColVisible(COL.EXP_DATE) && ` | Exp: ${expDate}`}
                            </Typography>
                        )}
                        {remark && isColVisible(COL.REMARK) && (
                            <Typography variant="caption" display="block" color="text.secondary">
                                Remark: {remark}
                            </Typography>
                        )}
                    </Box>
                );
            }
        },
        { field: 'qty', headerName: 'Qty', width: 50, align: 'center', headerAlign: 'center' },
        { field: 'rate', headerName: 'Rate', width: 100, align: 'right', headerAlign: 'center', renderCell: params => `₹${formatINR(params.row.rate)}` },
        { field: 'disc', headerName: 'Disc (%)', width: 50, align: 'center', headerAlign: 'center' },
        { field: 'amount', headerName: 'Amount ₹', width: 100, align: 'right', headerAlign: 'right', renderCell: params => `₹${formatINR(Number(params.row.TaxableAmt || 0))}` },
        {
            width: 30, sortable: false, filterable: false, align: 'center', headerAlign: 'center',
            renderCell: params => (
                <IconButton
                    size="small"
                    color="error"
                    disabled={isLocked}
                    onClick={() => !isLocked && deleteRow(params.row.index)}
                >
                    <DeleteIcon fontSize="small" />
                </IconButton>
            )
        }
    ];

    return (
        <Paper sx={{ p: 1, overflowX: 'hidden', mt: -1.5 }}>
            <Box display="flex" flexDirection={isSmall ? 'column' : 'row'} gap={2} sx={{ width: '100%', boxSizing: 'border-box', flexWrap: isSmall ? 'wrap' : 'nowrap', overflow: 'hidden' }} >
                <Box display="flex" flexDirection="column" gap={2} sx={{ width: '100%', maxWidth: isSmall ? '100%' : 420, boxSizing: 'border-box', p: 2, borderRight: isSmall ? 'none' : '1px solid #e0e0e0', flex: { lg: '1 1 100%' }, }} >
                    <Box>
                        <DropdownProductCode ref={productCodeRef} id="productCode" options={allProducts} value={current.productCode} onSelect={handleSelect} onNewProductAdded={loadAllProducts} connectionString={connectionString} onProductMasterClose={handleProductAdded} searchBy="code" autoFocus={!initialData?.tableData?.length} />
                        {!!errors.productCode && (
                            <Typography color="error" variant="caption">
                                {errors.productCode}
                            </Typography>
                        )}
                    </Box>
                    {/* <TextField label="Description" required fullWidth multiline minRows={1} size="small" placeholder="Enter product description" value={current.description} onChange={handleChange('description')} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 30 }, '& .MuiOutlinedInput-inputMultiline': { padding: '8px 12px', minHeight: '80px' } }} /> */}
                    {isColVisible(COL.DESCRIPTION) && (
                        <DropdownProductCode
                            id="description"
                            label="Description"
                            options={allProducts}
                            value={current.description}
                            onSelect={handleSelect}
                            onNewProductAdded={loadAllProducts}
                            connectionString={connectionString}
                            searchBy="description"   // ✅ IMPORTANT
                            onProductMasterClose={handleProductAdded}
                        />
                    )}
                    {(isColVisible(COL.PO_NO) || isColVisible(COL.PO_DATE) || isColVisible(COL.PO_QTY)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.PO_NO) && (
                                <TextField label={getColLabel(COL.PO_NO, 'PO No')} size="small" fullWidth value={current.PONo || ''} onChange={handleChange('PONo')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.PO_DATE) && (
                                <TextField label={getColLabel(COL.PO_DATE, 'PO Date')} type="date" size="small" fullWidth InputLabelProps={{ shrink: true }} value={current.PODate || ''} onChange={handleChange('PODate')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.PO_QTY) && (
                                <TextField label={getColLabel(COL.PO_QTY, 'PO Qty')} type="number" size="small" fullWidth value={current.poQty || ''} onChange={handleChange('poQty')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    <Box display="flex" flexDirection="row" gap={1.5}>
                        {isColVisible(COL.UNIT) && (
                            <TextField label="Unit" required select fullWidth size='small' value={String(current.UnitId)} onChange={handleChange('UnitId')} SelectProps={{ native: true }} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} >
                                <option value=""></option>
                                {unitOptions.map(u => (
                                    <option key={u.UnitId} value={u.UnitId}>
                                        {u.unit}
                                    </option>
                                ))}
                            </TextField>
                        )}
                        {/* <TextField label="Tax(%)" fullWidth type="number" disabled value={current.tax} onChange={handleChange('tax')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} /> */}
                        {isColVisible(COL.TAX_CODE) && (
                            <Dropdown
                                id="gst"
                                label="GST"
                                valueKey="Id"
                                labelKey="value"
                                value={current.TaxId ? String(current.TaxId) : ""}
                                options={gsts}
                                required
                                onChange={(opt) => {
                                    if (!opt) {
                                        setCurrent(prev => ({
                                            ...prev,
                                            tax: 0,
                                            TaxId: null
                                        }));
                                    } else {
                                        const gstValue = parseFloat(opt.value) || 0;

                                        // "Apply MRP in Sale?" — if MRP is already set on this
                                        // row, re-derive Rate from it using the newly-picked
                                        // GST rate, keeping Rate/MRP consistent.
                                        if (isApplyMRPInSaleEnabled && current.MRP && Number(current.MRP) > 0) {
                                            const newRate = calculateSaleRateFromMRP(Number(current.MRP), gstValue);
                                            const taxableAmt = current.qty * newRate * (1 - current.disc / 100);
                                            const taxAmount = taxableAmt * (gstValue / 100);
                                            const isSameState = areSameState(state, compState);

                                            setCurrent(prev => ({
                                                ...prev,
                                                tax: gstValue,
                                                TaxId: opt.Id,
                                                rate: newRate,
                                                amount: taxableAmt.toFixed(2),
                                                taxAmount: taxAmount.toFixed(2),
                                                CGST: isSameState ? (gstValue / 2).toFixed(2) : '0.00',
                                                SGST: isSameState ? (gstValue / 2).toFixed(2) : '0.00',
                                                IGST: !isSameState ? gstValue.toFixed(2) : '0.00',
                                                CGSTAmt: isSameState ? (taxAmount / 2).toFixed(2) : '0.00',
                                                SGSTAmt: isSameState ? (taxAmount / 2).toFixed(2) : '0.00',
                                                IGSTAmt: !isSameState ? taxAmount.toFixed(2) : '0.00',
                                                TaxableAmt: taxableAmt.toFixed(2),
                                            }));
                                            return;
                                        }

                                        setCurrent(prev => ({
                                            ...prev,
                                            tax: gstValue,   // % value used in calculation
                                            TaxId: opt.Id    // backend id
                                        }));
                                    }
                                }}
                                error={!!errors.TaxId}
                            />
                        )}
                    </Box>
                    {(isColVisible(COL.BATCH_NO) || isColVisible(COL.EXP_DATE)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.BATCH_NO) && (
                                <TextField label={getColLabel(COL.BATCH_NO, 'Batch No')} size="small" fullWidth value={current.batchNo} onChange={handleChange('batchNo')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.EXP_DATE) && (
                                <TextField label={getColLabel(COL.EXP_DATE, 'Exp. Date')} type="date" size="small" fullWidth InputLabelProps={{ shrink: true }} value={current.expDate} onChange={handleChange('expDate')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {isApplyMRPInSaleEnabled ? (
                        // When Apply MRP in Sale is enabled: Qty, MRP, Rate, Disc in single row
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {isColVisible(COL.QTY) && (
                                <Box sx={{ flex: 0.75, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                                    <TextField label="Qty" required size='small' fullWidth type="number" inputProps={{ min: 0, step: 'any' }} value={current.qty} onChange={handleChange('qty')} error={!!errors.qty} helperText={errors.qty} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                                </Box>
                            )}
                            <Box sx={{ flex: 1, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                                <TextField
                                    label="MRP"
                                    size='small'
                                    fullWidth
                                    type="number"
                                    inputProps={{ min: 0 }}
                                    value={current.MRP}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        const mrpValue = Number(val) || 0;

                                        setCurrent(prev => ({
                                            ...prev,
                                            MRP: val === '' ? '' : mrpValue
                                        }));

                                        if (mrpValue > 0 && current.tax > 0) {
                                            const isSameState = areSameState(state, compState);
                                            const newRate = calculateSaleRateFromMRP(mrpValue, current.tax);
                                            const taxableAmt = current.qty * newRate * (1 - current.disc / 100);
                                            const taxAmount = taxableAmt * (current.tax / 100);

                                            setCurrent(prev => ({
                                                ...prev,
                                                rate: newRate,
                                                amount: taxableAmt.toFixed(2),
                                                taxAmount: taxAmount.toFixed(2),
                                                CGST: isSameState ? (current.tax / 2).toFixed(2) : '0.00',
                                                SGST: isSameState ? (current.tax / 2).toFixed(2) : '0.00',
                                                IGST: !isSameState ? current.tax.toFixed(2) : '0.00',
                                                CGSTAmt: isSameState ? (taxAmount / 2).toFixed(2) : '0.00',
                                                SGSTAmt: isSameState ? (taxAmount / 2).toFixed(2) : '0.00',
                                                IGSTAmt: !isSameState ? taxAmount.toFixed(2) : '0.00',
                                                TaxableAmt: taxableAmt.toFixed(2)
                                            }));
                                        }
                                    }}
                                    InputLabelProps={{ sx: requiredAsteriskStyle }}
                                    sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }}
                                />
                            </Box>
                            {isColVisible(COL.RATE) && (
                                <Box sx={{ flex: 1, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                                    <TextField label="Rate" required size='small' fullWidth type="number" inputProps={{ min: 0 }} value={current.rate} onChange={handleChange('rate')} disabled={true} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                                </Box>
                            )}
                            {isColVisible(COL.DISC) && (
                                <Box sx={{ flex: 0.75, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                                    <TextField label={getColLabel(COL.DISC, 'Disc%')} size='small' fullWidth type="number" inputProps={{ min: 0, max: 100 }} value={current.disc} onChange={handleChange('disc')} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                                </Box>
                            )}
                        </Box>
                    ) : (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.QTY) && (
                                <TextField label="Qty" required size='small' fullWidth type="number" inputProps={{ min: 0, step: 'any' }} value={current.qty} onChange={handleChange('qty')} error={!!errors.qty} helperText={errors.qty} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.RATE) && (
                                <TextField label="Rate" required size='small' fullWidth type="number" inputProps={{ min: 0 }} value={current.rate} onChange={handleChange('rate')} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.DISC) && (
                                <TextField label={getColLabel(COL.DISC, 'Disc%')} size='small' fullWidth type="number" inputProps={{ min: 0, max: 100 }} value={current.disc} onChange={handleChange('disc')} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {(isColVisible(COL.TYPE) || isColVisible(COL.SIZE) || isColVisible(COL.COLOR)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.TYPE) && (
                                <TextField label={getColLabel(COL.TYPE, 'Type')} size="small" fullWidth value={current.type} onChange={handleChange('type')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.SIZE) && (
                                <TextField label={getColLabel(COL.SIZE, 'Size')} size="small" fullWidth value={current.size} onChange={handleChange('size')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.COLOR) && (
                                <TextField label={getColLabel(COL.COLOR, 'Color')} size="small" fullWidth value={current.color} onChange={handleChange('color')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {(isColVisible(COL.PKG) || isColVisible(COL.FREE_QTY) || isColVisible(COL.PER)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.PKG) && (
                                <TextField label={getColLabel(COL.PKG, 'Pkg')} size="small" fullWidth value={current.pkg || ''} onChange={handleChange('pkg')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.FREE_QTY) && (
                                <TextField label={getColLabel(COL.FREE_QTY, 'Free Qty')} type="number" size="small" fullWidth value={current.freeQty} onChange={handleChange('freeQty')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.PER) && (
                                <TextField label={getColLabel(COL.PER, 'Per')} size="small" fullWidth value={current.per} onChange={handleChange('per')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {(isColVisible(COL.OTH1) || isColVisible(COL.OTH2) || isColVisible(COL.OTH3)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.OTH1) && (
                                <TextField label={getColLabel(COL.OTH1, 'Oth 1')} size="small" fullWidth value={current.oth1} onChange={handleChange('oth1')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH2) && (
                                <TextField label={getColLabel(COL.OTH2, 'Oth 2')} size="small" fullWidth value={current.oth2} onChange={handleChange('oth2')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH3) && (
                                <TextField label={getColLabel(COL.OTH3, 'Oth 3')} size="small" fullWidth value={current.oth3} onChange={handleChange('oth3')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {(isColVisible(COL.UTGST) || isColVisible(COL.GST_CESS)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.UTGST) && (
                                <TextField label={getColLabel(COL.UTGST, 'UTGST')} size="small" fullWidth type="number" value={current.UTGST} onChange={handleChange('UTGST')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.GST_CESS) && (
                                <TextField label={getColLabel(COL.GST_CESS, 'GST Cess')} size="small" fullWidth type="number" value={current.GSTCess} onChange={handleChange('GSTCess')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {/* {isColVisible(COL.GST_OTH) && (
                                <TextField label={getColLabel(COL.GST_OTH, 'GST Oth')} size="small" fullWidth type="number" value={current.GSTOth} onChange={handleChange('GSTOth')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )} */}
                        </Box>
                    )}
                    {/* PO Qty / EX4 */}
                    {(isColVisible(COL.GST_OTH) || isColVisible(COL.EX4)) && (
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 2 }}>
                            {isColVisible(COL.GST_OTH) && (
                                <TextField label={getColLabel(COL.GST_OTH, 'GST Oth')} size="small" fullWidth type="number" value={current.GSTOth} onChange={handleChange('GSTOth')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.EX4) && (
                                <TextField
                                    size="small"
                                    label={getColLabel(COL.EX4, 'EX4')}
                                    value={current.ex4 || ''}
                                    onChange={(e) => setCurrent(p => ({ ...p, ex4: e.target.value }))}
                                    disabled={isLocked}
                                />
                            )}
                        </Box>
                    )}
                    {/* EX5 / EXQty6 */}
                    {(isColVisible(COL.EX5) || isColVisible(COL.EX_QTY6)) && (
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 2 }}>
                            {isColVisible(COL.EX5) && (
                                <TextField
                                    size="small"
                                    label={getColLabel(COL.EX5, 'EX5')}
                                    value={current.ex5 || ''}
                                    onChange={(e) => setCurrent(p => ({ ...p, ex5: e.target.value }))}
                                    disabled={isLocked}
                                />
                            )}
                            {isColVisible(COL.EX_QTY6) && (
                                <TextField
                                    size="small"
                                    label={getColLabel(COL.EX_QTY6, 'EXQty6')}
                                    type="number"
                                    value={current.exQty6 || ''}
                                    onChange={(e) => setCurrent(p => ({ ...p, exQty6: e.target.value }))}
                                    disabled={isLocked}
                                />
                            )}
                        </Box>
                    )}
                    {/* Grade */}
                    {isColVisible(COL.SERIAL_NO) && (
                        <TextField
                            size="small"
                            label={getColLabel(COL.SERIAL_NO, 'Serial No')}
                            value={current.serialNo || ''}
                            onChange={(e) => setCurrent(p => ({ ...p, serialNo: e.target.value }))}
                            disabled={isLocked}
                            fullWidth
                        />
                    )}
                    {/* Oth 4 / Oth 5 */}
                    {(isColVisible(COL.OTH4) || isColVisible(COL.OTH5)) && (
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 2 }}>
                            {isColVisible(COL.OTH4) && (
                                <TextField
                                    size="small"
                                    label={getColLabel(COL.OTH4, 'Oth 4')}
                                    value={current.oth4 || ''}
                                    onChange={(e) => setCurrent(p => ({ ...p, oth4: e.target.value }))}
                                    disabled={isLocked}
                                />
                            )}
                            {isColVisible(COL.OTH5) && (
                                <TextField
                                    size="small"
                                    label={getColLabel(COL.OTH5, 'Oth 5')}
                                    value={current.oth5 || ''}
                                    onChange={(e) => setCurrent(p => ({ ...p, oth5: e.target.value }))}
                                    disabled={isLocked}
                                />
                            )}
                        </Box>
                    )}
                    {/* Oth 6 / Oth 7 */}
                    {(isColVisible(COL.OTH6) || isColVisible(COL.OTH7)) && (
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 2 }}>
                            {isColVisible(COL.OTH6) && (
                                <TextField
                                    size="small"
                                    label={getColLabel(COL.OTH6, 'Oth 6')}
                                    value={current.oth6 || ''}
                                    onChange={(e) => setCurrent(p => ({ ...p, oth6: e.target.value }))}
                                    disabled={isLocked}
                                />
                            )}
                            {isColVisible(COL.OTH7) && (
                                <TextField
                                    size="small"
                                    label={getColLabel(COL.OTH7, 'Oth 7')}
                                    value={current.oth7 || ''}
                                    onChange={(e) => setCurrent(p => ({ ...p, oth7: e.target.value }))}
                                    disabled={isLocked}
                                />
                            )}
                        </Box>
                    )}
                    {isColVisible(COL.AMOUNT) && (
                        <TextField label="Amount" fullWidth disabled type="number" size="small" value={current.amount} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                    )}
                    {isColVisible(COL.REMARK) && (
                        <Box>
                            <TextField label="Remark" fullWidth multiline minRows={1} maxRows={3} size="small" value={current.remark || ''} onChange={handleChange('remark')} inputProps={{ maxLength: 250 }} helperText={`${(current.remark || '').length}/250 characters`} />
                        </Box>
                    )}
                    <Box display="flex" justifyContent="center">
                        <Button variant="outlined" onClick={addProduct} sx={{ minWidth: 180 }} disabled={isLocked}>
                            {editIndex != null ? 'Update Product' : 'Add Product'}
                        </Button>
                    </Box>
                </Box>
                <Box sx={{ width: isSmall ? '100%' : 670, maxWidth: '100%', p: isSmall ? 0 : 0, marginTop: isMobile ? -1 : -4, flexShrink: 0 }}>
                    {isMobile ? (
                        <Box>
                            {rows.filter(r => r.TransType !== 200 && r.TransType !== 201 && r.TransType !== 202 && r.TransType !== 203 && r.TransType !== 204 && r.TransType !== 300).map((row, i) => (
                                <Box
                                    key={i}
                                    sx={{
                                        border: "1px solid #cbd5e1",
                                        borderRadius: 2,
                                        p: 1.5,
                                        mb: 1.5,
                                        color: isLocked && "text.disabled",
                                        cursor: isLocked ? "not-allowed" : "pointer",
                                    }}

                                >
                                    <Typography sx={{ fontWeight: 600 }}>
                                        {row.productCode} —{" "}
                                        <Box
                                            component="span"
                                            sx={{
                                                fontStyle: "italic",
                                                fontWeight: "normal",
                                                display: "inline",
                                                wordBreak: "break-word",
                                                whiteSpace: "normal"
                                            }}
                                        >
                                            {row.description}
                                        </Box>
                                    </Typography>

                                    <Grid container justifyContent="space-between">
                                        <Typography>Qty:</Typography>
                                        <Typography>{row.qty}</Typography>
                                    </Grid>

                                    <Grid container justifyContent="space-between">
                                        <Typography>Rate:</Typography>
                                        <Typography>₹{row.rate}</Typography>
                                    </Grid>

                                    <Grid container justifyContent="space-between">
                                        <Typography>Disc:</Typography>
                                        <Typography>{row.disc}%</Typography>
                                    </Grid>

                                    <Grid container justifyContent="space-between">
                                        <Typography>Amount:</Typography>
                                        <Typography>₹{row.amount}</Typography>
                                    </Grid>

                                    {/* TAX INFO */}
                                    <Grid container justifyContent="space-between">
                                        <Typography>GST:</Typography>
                                        <Typography>{row.tax}%</Typography>
                                    </Grid>

                                    {state?.toLowerCase() === compState?.toLowerCase() ? (
                                        <>
                                            <Grid container justifyContent="space-between">
                                                <Typography>CGST:</Typography>
                                                <Typography>₹{formatINR(row.CGSTAmt)}</Typography>
                                            </Grid>
                                            <Grid container justifyContent="space-between">
                                                <Typography>SGST:</Typography>
                                                <Typography>₹{formatINR(row.SGSTAmt)}</Typography>
                                            </Grid>
                                        </>
                                    ) : (
                                        <Grid container justifyContent="space-between">
                                            <Typography>IGST:</Typography>
                                            <Typography>₹{formatINR(row.IGSTAmt)}</Typography>
                                        </Grid>
                                    )}

                                    {/* Remark */}
                                    {row.remark && row.remark.trim() !== '' && (
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                mt: 1,
                                                display: 'block',
                                                wordBreak: 'break-word',
                                                overflowWrap: 'anywhere',
                                                whiteSpace: 'normal'
                                            }}
                                        >
                                            Remark: {row.remark}
                                        </Typography>
                                    )}

                                    {/* DELETE / EDIT BUTTONS IF NEEDED */}
                                    <Box display="flex" justifyContent="flex-end" mt={1} gap={0.5}>
                                        <IconButton size="small" onClick={() => editRow(i)} disabled={isLocked}>
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                        <IconButton size="small" color="error" disabled={isLocked} onClick={() => !isLocked && deleteRow(i)}>
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    ) : (
                        <DataGrid
                            rows={rows.filter(r => r.TransType !== 200 && r.TransType !== 201 && r.TransType !== 202 && r.TransType !== 203 && r.TransType !== 204 && r.TransType !== 300).map((r, i) => ({ ...r, id: i + 1, index: i }))}
                            columns={columns}
                            getRowHeight={() => 'auto'}
                            autoHeight
                            disableRowSelectionOnClick
                            hideFooter
                            sx={{
                                mt: 5,
                                border: '1px solid #cbd5e1',
                                borderRadius: 1,
                                '& .MuiDataGrid-columnHeaders': { minHeight: 55, maxHeight: 55 },
                                '& .MuiDataGrid-columnHeader': { backgroundColor: '#f0f0f0', paddingTop: '4px', paddingBottom: '4px', height: 42, lineHeight: '1.2rem', fontSize: '13px' },
                                '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#edf2feff' },
                                '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#ffffff' }
                            }}
                        />
                    )}

                    <Box mt={3}>
                        <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography>Basic Amount</Typography>
                            <Typography>₹{formatINR(totals.basic)}</Typography>
                        </Grid>
                        <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography>Discounted Amount</Typography>
                            <Typography>₹{formatINR(totals.discount)}</Typography>
                        </Grid>

                        {/* ✅ MOVED: Charges button now below Discounted Amount */}
                        {additionalCharges.length > 0 && (
                            <Box mb={2}>
                                <Accordion
                                    expanded={chargesCollapsibleOpen !== false ? true : chargesCollapsibleOpen}
                                    onChange={() => setChargesCollapsibleOpen(!chargesCollapsibleOpen)}
                                    sx={{ width: '100%' }}
                                >
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ minHeight: 'auto' }}>
                                        <Typography variant="subtitle2">Charges</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ py: 1, px: 1 }}>
                                        {/* ✅ IMPROVED: Tabular format with headers and borders, reduced height */}
                                        <Box sx={{ width: '100%', overflowX: 'auto' }}>
                                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                <colgroup>
                                                    <col style={{ width: '45%' }} />
                                                    <col style={{ width: '18%' }} />
                                                    <col style={{ width: '18%' }} />
                                                    <col style={{ width: '19%' }} />
                                                </colgroup>
                                                <thead>
                                                    <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '2px solid #ddd' }}>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', borderRight: '1px solid #ddd', fontWeight: 600, fontSize: '12px' }}>Charge Name</th>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', borderRight: '1px solid #ddd', fontWeight: 600, fontSize: '12px' }}>Amount</th>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', borderRight: '1px solid #ddd', fontWeight: 600, fontSize: '12px' }}>Tax</th>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', fontWeight: 600, fontSize: '12px' }}>Final Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {additionalCharges.map((charge, index) => {
                                                        const key = charge.TransType;
                                                        // ✅ FIX: Ensure chargeInputs[key] is initialized with both amount and taxId
                                                        if (!chargeInputs[key]) {
                                                            updateChargeInput(key, { amount: '', taxId: charge.TaxId ?? null });
                                                        }
                                                        const input = chargeInputs[key] || { amount: '', taxId: charge.TaxId ?? null };
                                                        const { finalAmount } = getChargeFinalAmounts(charge, input);

                                                        return (
                                                            <tr key={key} style={{ borderBottom: '1px solid #ddd' }}>
                                                                <td style={{ padding: '6px 8px', borderRight: '1px solid #ddd', verticalAlign: 'middle' }}>
                                                                    <Typography variant="caption" sx={{ fontSize: '12px' }}>{charge.ChargeName}</Typography>
                                                                </td>
                                                                <td style={{ padding: '6px 8px', borderRight: '1px solid #ddd', verticalAlign: 'middle' }}>
                                                                    <TextField
                                                                        size="small"
                                                                        fullWidth
                                                                        type="number"
                                                                        value={input.amount}
                                                                        onChange={(e) => updateChargeInput(key, { amount: e.target.value })}
                                                                        sx={{ '& .MuiOutlinedInput-root': { height: 30, fontSize: '12px' } }}
                                                                    />
                                                                </td>
                                                                <td style={{ padding: '6px 8px', borderRight: '1px solid #ddd', verticalAlign: 'middle' }}>
                                                                    {charge.TaxEnabled ? (
                                                                        <Dropdown
                                                                            id={`charge-tax-${key}`}
                                                                            valueKey="Id"
                                                                            labelKey="value"
                                                                            value={input.taxId ? String(input.taxId) : ""}
                                                                            options={gsts}
                                                                            onChange={(opt) => updateChargeInput(key, { taxId: opt ? opt.Id : null })}
                                                                        />
                                                                    ) : (
                                                                        <Typography variant="caption" sx={{ color: '#999', fontSize: '12px' }}>N/A</Typography>
                                                                    )}
                                                                </td>
                                                                <td style={{ padding: '6px 8px', verticalAlign: 'middle' }}>
                                                                    <TextField
                                                                        size="small"
                                                                        fullWidth
                                                                        type="number"
                                                                        value={finalAmount.toFixed(2)}
                                                                        disabled
                                                                        sx={{ '& .MuiOutlinedInput-root': { height: 30, backgroundColor: '#f5f5f5', fontSize: '12px' } }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </Box>
                                        {/* ✅ REMOVED: Save button - charges are now auto-saved on input change */}
                                    </AccordionDetails>
                                </Accordion>
                            </Box>
                        )}

                        {areSameState(state, compState) ? (
                            <>
                                <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography>CGST</Typography>
                                    <Typography>₹{formatINR(Number(totals.cgst) + chargesSummary.cgst)}</Typography>
                                </Grid>
                                <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography>SGST</Typography>
                                    <Typography>₹{formatINR(Number(totals.sgst) + chargesSummary.sgst)}</Typography>
                                </Grid>
                            </>
                        ) : (
                            totals.igst > 0 && (
                                <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography>IGST</Typography>
                                    <Typography>₹{formatINR(Number(totals.igst) + chargesSummary.igst)}</Typography>
                                </Grid>
                            )
                        )}
                        <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography>Round Off ({Number(totals.roundOff) >= 0 ? '+' : '-'})</Typography>
                            <Typography>₹{formatINR(totals.roundOff)}</Typography>
                        </Grid>

                        <Divider sx={{ my: 1 }} />
                        <Grid container justifyContent="space-between" alignItems="center">
                            <Typography fontWeight={600}>Total Amount</Typography>
                            <Typography fontWeight={600}>₹{formatINR(Number(totals.total))}</Typography>
                        </Grid>
                    </Box>
                </Box>
            </Box>
            {!!errors.global && (
                <Typography color="error" sx={{ mt: 2 }}>
                    {errors.global}
                </Typography>
            )}
            <Box mt={1} display="flex" justifyContent="flex-end">
                <Button
                    variant="contained"
                    onClick={handleNext}
                    disabled={editIndex !== null}
                >
                    Next
                </Button>
            </Box>


            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })} >
                <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }} variant="filled">
                    {snackbar.message}
                </Alert>
            </Snackbar>

            {/* ✅ REMOVED: Charges dialog moved to collapsible accordion below Discounted Amount */}
        </Paper>
    );
};

export default ProductDetails;